<!-- 编辑销售单 5-17优化 -->
<template>
    <div class="business-content-main sales-order-edit-v2" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <!--   form     -->
            <div class="section-title" @click="showMsg">
                <div>
                    <span>订单信息{{ submitData.OrderCode ? '【' + submitData.OrderCode + '】' : '' }}</span>
                    <span v-if="!showOrderMsg && submitData.EntpCusName">&nbsp;&nbsp;&nbsp;&nbsp;客户：{{ submitData.EntpCusName }}</span>
                    <span v-if="type == 7" style="font-size: 14px; margin-left: 10px; color: red">
                        （ 温馨提醒：重新开单只会生成新的销售订单，将不影响旧的销售订单 ）
                    </span>
                </div>
                <div>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="lceHandle(1)"
                        v-if="!dataReadonly && (type == 2 || type == 3 || type == 7 || type == 8) && permission.AddLogistics"
                        >{{ permission.AddLogistics }}</el-button
                    >
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="lceHandle(2)"
                        v-if="this.submitData.LogisticId && !dataReadonly && (type == 2 || type == 3 || type == 7 || type == 8) && permission.EditLogistics"
                        >{{ permission.EditLogistics }}</el-button
                    >
                    <el-button size="small" class="search-btn btn-primary" @click="showReceipt()" v-if="permission.moneyIn && (type == 1 || type == 5 || type == 8)">{{
                        type == 5 ? permission.moneyIn : '收款记录'
                    }}</el-button>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="outWarehouse()"
                        v-if="(permission.goodOutAll || permission3.saleOut) && !submitData.IsDelivery && type == 6"
                        >整单出仓</el-button
                    >
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="addCustomer(1)"
                        v-if="!dataReadonly && (type == 2 || type == 3 || type == 7) && permission.addCustomer"
                        >{{ permission.addCustomer }}</el-button
                    >
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="addCustomer(2)"
                        v-if="!dataReadonly && (type == 2 || type == 3 || type == 7) && permission.editCustomer && submitData.EntpCusId"
                        >{{ permission.editCustomer }}</el-button
                    >
                </div>
            </div>
            <div class="open-icon" @click="showMsg" v-if="!showOrderMsg">
                <img src="../../../assets/images/open-msg.png" />
            </div>
            <div class="order-infoes" v-show="showOrderMsg">
                <el-form :model="submitData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 30px; padding-left: 30px" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="选择客户" prop="EntpCusId">
                                    <el-input size="small" v-if="type == 4" disabled v-model.trim="submitData.EntpCusName"></el-input>
                                    <el-select
                                        size="small"
                                        style="width: 100%"
                                        v-else
                                        :disabled="dataReadonly || type == 8"
                                        v-model="submitData.EntpCusId"
                                        filterable
                                        clearable
                                        remote
                                        reserve-keyword
                                        :remote-method="searchCustomer"
                                        v-select-scroll-more="searchCustomLoad"
                                        @change="customerChange($event)"
                                        @visible-change="customerVisibleChange($event)"
                                        placeholder="输入客户名称/电话"
                                    >
                                        <el-option
                                            v-for="optionItem in customerList"
                                            :key="optionItem.EntpCusId"
                                            :data-msg="optionItem"
                                            :label="optionItem.EntpCusName"
                                            :value="optionItem.EntpCusId"
                                        >
                                            <span style="float: left">
                                                {{ optionItem.EntpCusName }}
                                            </span>
                                            <span style="float: right; color: #8492a6; font-size: 13px">{{ optionItem.CallNum }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="业务员" prop="SId">
                                    <el-select
                                        size="small"
                                        v-model="submitData.SId"
                                        :disabled="dataReadonly"
                                        filterable
                                        clearable
                                        placeholder="请选择"
                                        @change="sIdChange($event)"
                                        @visible-change="siVisibleChange($event)"
                                        style="width: 100%"
                                    >
                                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="联系电话" prop="PhoneNum">
                                    <el-input size="small" :disabled="dataReadonly || !yxbPermission" v-model.trim="submitData.PhoneNum"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="发货方式" prop="ShipType">
                                    <el-select size="small" v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择" style="width: 100%">
                                        <el-option v-for="item in DeliveryMethodList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="运输费用" prop="ShipAmount">
                                    <el-input
                                        size="small"
                                        min="0"
                                        type="number"
                                        step="0.01"
                                        :disabled="dataReadonly || !yxbPermission"
                                        v-model.trim="submitData.ShipAmount"
                                        @change="resetHeight"
                                    ></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="结算方式" prop="PayType">
                                    <el-select
                                        size="small"
                                        v-model="submitData.PayType"
                                        :disabled="dataReadonly || !yxbPermission"
                                        placeholder="请选择"
                                        style="width: 100%"
                                    >
                                        <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="出仓仓库" prop="WarehouseId">
                                    <el-input
                                        v-if="dataReadonly || ((submitData.IsPartialOutWarehouse || submitData.IsDelivery) && warehouseList.length == 1)"
                                        :title="submitData.WarehouseName"
                                        v-model="submitData.WarehouseName"
                                        style="width: 100%"
                                        size="small"
                                        :disabled="true"
                                    ></el-input>
                                    <el-select
                                        v-else
                                        size="small"
                                        v-model="submitData.WarehouseId"
                                        :disabled="dataReadonly"
                                        placeholder="请选择"
                                        style="width: 100%"
                                        filterable
                                        clearable
                                        @visible-change="warehouseVisibleChange($event)"
                                        @change="warehouseChange"
                                    >
                                        <el-option
                                            v-for="optionItem in warehouseList"
                                            :key="optionItem.WarehouseId"
                                            :label="optionItem.WarehouseName"
                                            :value="optionItem.WarehouseId"
                                        >
                                            <span style="float: left">
                                                {{ optionItem.WarehouseName }}
                                            </span>
                                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5" v-if="funcConfig">
                            <div class="grid-content bg-purple">
                                <el-form-item label="跟单采购员" prop="FollowerId">
                                    <el-select
                                        size="small"
                                        v-model="submitData.FollowerId"
                                        :disabled="dataReadonly"
                                        filterable
                                        clearable
                                        placeholder="请选择"
                                        @change="followerChange($event)"
                                        @visible-change="siVisibleChange($event)"
                                        style="width: 100%"
                                    >
                                        <el-option v-for="(item, index) in FollowerList" :key="index" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="物流公司" prop>
                                    <el-input
                                        size="small"
                                        v-if="dataReadonly"
                                        :title="submitData.LogisticName"
                                        v-model="submitData.LogisticName"
                                        style="width: 100%"
                                        :disabled="true"
                                    ></el-input>
                                    <el-select
                                        size="small"
                                        v-else
                                        style="width: 100%"
                                        v-model="submitData.LogisticItem"
                                        value-key="EntpCusId"
                                        placeholder="请输入物流公司"
                                        filterable
                                        clearable
                                        default-first-option
                                        remote
                                        reserve-keyword
                                        :remote-method="searchLogistic"
                                        @visible-change="logisticVisibleChange($event)"
                                        @change="logisticChange"
                                    >
                                        <el-option v-for="item in logisticsList" :key="item.EntpCusId" :data-msg="item" :label="item.EntpCusName" :value="item">
                                            <div class="name">
                                                {{ item.EntpCusName }}
                                                <span class="phone" v-if="item.Phone">{{ ' ( 电话：' + item.Phone + ' )' }}</span>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="物流单号" prop="LogisticsOrderNo">
                                    <el-input size="small" :disabled="dataReadonly" v-model.trim="submitData.LogisticsOrderNo" :max="30"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col v-if="isOrgShow" :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="部门" prop="OrgId">
                                    <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.OrgName"></el-input>
                                    <el-select
                                        size="small"
                                        style="width: 100%"
                                        v-else
                                        :disabled="dataReadonly"
                                        v-model="submitData.OrgId"
                                        filterable
                                        clearable
                                        reserve-keyword
                                        @change="orgChange($event)"
                                        @visible-change="orgVisibleChange($event)"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="optionItem in orgList"
                                            :key="optionItem.Id"
                                            :data-msg="optionItem"
                                            :label="optionItem.Name"
                                            :value="optionItem.Id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="isUseSource ? 5 : 7">
                            <div class="grid-content bg-purple">
                                <el-form-item label="收货地址" prop="FullAddress">
                                    <el-autocomplete
                                        size="small"
                                        :disabled="dataReadonly || !yxbPermission"
                                        v-model.trim="submitData.FullAddress"
                                        style="width: 100%"
                                        :fetch-suggestions="querySearch"
                                    ></el-autocomplete>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="isUseSource ? 10 : 12">
                            <div class="customer-view">
                                <el-form-item label="客人要求" class="grid-content bg-purple">
                                    <el-tooltip :content="submitData.Remark" placement="top" effect="light" v-if="submitData.Remark && dataReadonly">
                                        <el-input size="small" :disabled="dataReadonly" v-model="submitData.Remark"></el-input>
                                    </el-tooltip>
                                    <el-input size="small" v-else :disabled="dataReadonly" v-model="submitData.Remark"></el-input>
                                </el-form-item>
                                <div class="customer-checked" v-if="isEdit">
                                    <el-checkbox v-model="customerChecked">提交后是否展示到下次订单中？</el-checkbox>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="4" v-if="isUseSource">
                            <div class="grid-content bg-purple">
                                <el-form-item label="订单来源" prop="CusSources">
                                    <el-input size="small" v-if="dataReadonly" disabled v-model="submitData.CusSourcesName"></el-input>
                                    <el-select
                                        style="width: 100%"
                                        size="small"
                                        v-else
                                        :disabled="dataReadonly"
                                        v-model="submitData.CusSources"
                                        filterable
                                        clearable
                                        reserve-keyword
                                        @change="sourceChange($event)"
                                        @visible-change="sourceVisibleChange($event)"
                                        placeholder="请选择"
                                    >
                                        <el-option
                                            v-for="optionItem in cusSourcesList"
                                            :key="optionItem.Value"
                                            :data-msg="optionItem"
                                            :label="optionItem.Text"
                                            :value="optionItem.Value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!--    table    -->
            <div class="section-title" @click="hideMsg()">
                <div>
                    商品明细
                    <span v-if="type == 8" style="font-size: 14px; margin-left: 10px; color: red">
                        （ 温馨提醒：已出仓的商品不能再进行修改！部分出仓的商品数量可修改，但不能少于已出仓数！ ）
                    </span>
                </div>
                <div>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="showSearch()"
                        tabindex="-1"
                        v-if="!dataReadonly && (type == 2 || type == 3 || type == 4 || type == 7 || type == 8) && yxbPermission"
                        >搜索配件(F2)</el-button
                    >
                </div>
            </div>
        </div>
        <!-- table body -->
        <div id="infinite-list" :class="infiniteListClass" @click="hideMsg()">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                show-summary
                :summary-method="setSummaries"
                :row-style="setRowStyle"
                highlight-current-row
                row-id="rowkey"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="65" resizable></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i
                                    :class="['el-icon-caret-top', { active: sortActive === 'top' }]"
                                    title="升序,从小到大排序"
                                    @click="changeTableSort('top', 'APCode')"
                                ></i>
                                <i
                                    :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]"
                                    title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"
                                ></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle(row.IsNew, 'sapcode')">
                            <span class="sp-i">
                                <i v-if="row.MainImage" title="有图片的配件信息" class="el-icon-picture" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                                <i v-else title="配件信息" class="el-icon-info" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)"></i>
                            </span>
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            style="width: 100%"
                            ref="sapcode"
                            :disabled="
                                dataReadonly ||
                                (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                                (type == 4 && !scope.row.canEdit) ||
                                (type == 8 && scope.row.WarehousedCount > 0) ||
                                !yxbPermission
                            "
                            :allow-create="isCheckCode"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            :remote-method="
                                query => {
                                    searchCode(query, scope.row, scope.rowIndex);
                                }
                            "
                            v-select-scroll-more="searchCodeLoad"
                            popper-class="el-select-style-gray"
                            @keyup.enter.native="keyEvent($event, 'APCode', scope.row, scope.rowIndex)"
                            @keyup.right.native="keyEvent($event, 'APCode')"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="isCheckCode ? optionItem.APCode : optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodNameItem" title="配件名称" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle(row.IsNew, 'partsNameSelect')">{{ row.GoodName }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            placeholder="配件名称"
                            v-model="scope.row.GoodName"
                            v-if="scope.row.IsNew"
                            :disabled="scope.row.hasLock && lastRowIndex !== scope.rowIndex"
                        ></el-input>
                        <el-select
                            v-else
                            ref="partsNameSelect"
                            style="width: 100%"
                            :disabled="
                                dataReadonly ||
                                (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                                (type == 4 && !scope.row.canEdit) ||
                                (type == 8 && scope.row.WarehousedCount > 0) ||
                                !yxbPermission
                            "
                            allow-create
                            size="small"
                            v-model="scope.row.GoodName"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @change="nameChange($event, scope.rowIndex)"
                            @visible-change="apNameVisibleChange($event)"
                            :remote-method="
                                query => {
                                    searchName(query, scope.row, scope.rowIndex);
                                }
                            "
                            v-select-scroll-more="searchNameLoad"
                            popper-class="el-select-style-gray"
                            @keyup.enter.native="keyEvent($event, 'GoodName')"
                            @keyup.right.native="keyEvent($event, 'GoodName')"
                            @keyup.left.native="keyEvent($event, 'GoodName')"
                        >
                            <el-option
                                v-for="optionItem in nameList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.GoodName"
                                :value="optionItem"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle(row.IsNew, 'autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.AutoSerise"
                            placeholder="车系"
                            v-if="scope.row.IsNew"
                            :disabled="scope.row.hasLock && lastRowIndex !== scope.rowIndex"
                        ></el-input>
                        <el-select
                            v-else
                            ref="autoSeriseSelect"
                            style="width: 100%"
                            :disabled="
                                dataReadonly ||
                                (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                                (type == 4 && !scope.row.canEdit) ||
                                (type == 8 && scope.row.WarehousedCount > 0) ||
                                !yxbPermission
                            "
                            allow-create
                            size="small"
                            v-model="scope.row.AutoSeriseItem"
                            value-key="EntpTempGoodsId"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车系"
                            @visible-change="autoSeriseVisibleChange($event, scope.row)"
                            :remote-method="
                                query => {
                                    searchAutoSerie(query, scope.row, scope.rowIndex);
                                }
                            "
                            v-select-scroll-more="searchAutoSerieLoad"
                            @change="seriseChange($event, scope.rowIndex)"
                            popper-class="el-select-style-gray"
                            @keyup.enter.native="keyEvent($event, 'AutoSerise')"
                            @keyup.right.native="keyEvent($event, 'AutoSerise')"
                            @keyup.left.native="keyEvent($event, 'AutoSerise')"
                        >
                            <el-option
                                v-for="optionItem in seriesList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.AutoSerise"
                                :value="optionItem"
                            >
                                <div class="option-content">
                                    <div class="project-Name" style="width: 300px">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="160" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle(row.IsNew, 'originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            ref="originRef"
                            size="small"
                            v-model="scope.row.Origin"
                            @keyup.right.native="keyEvent($event, 'Origin')"
                            @keyup.left.native="keyEvent($event, 'Origin')"
                            @focus="selectAutoHandle('originRef')"
                            :disabled="dataReadonly || !yxbPermission"
                        ></el-input>
                    </template>
                </ux-table-column>
                <!--autofocus，如果是自定义渲染可以指定聚焦的选择器，他的作用很明显就是你点击一下就帮你去获取焦点。
                你无需点击第二次再去获取焦点。autofocus的值就是你编辑型输入框（edit）组件的类名-->
                <ux-table-column field="Count" title="数量" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="salecounts-input-cell">
                            <el-input-number
                                type="number"
                                ref="countRef"
                                :min="type != 7 ? (scope.row.WarehousedCount > 0 ? scope.row.WarehousedCount : 1) : 1"
                                :precision="0"
                                controls-position="right"
                                size="small"
                                v-model="scope.row.Count"
                                @change="priceChange"
                                @keyup.enter.native="keyEvent($event, 'Count')"
                                @keyup.right.native="keyEvent($event, 'Count')"
                                @keyup.left.native="keyEvent($event, 'Count')"
                                @focus="selectAutoHandle('countRef')"
                                :disabled="dataReadonly || (type == 8 && scope.row.IsDelivery) || !yxbPermission"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.Unit }]" @click="focusHandle(row.IsNew, 'unitSelect')">{{ row.Unit }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="unitSelect"
                            :disabled="dataReadonly || (type == 4 && !scope.row.canEdit) || (type == 8 && scope.row.WarehousedCount > 0) || !yxbPermission"
                            default-first-option
                            size="small"
                            v-model="scope.row.Unit"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="单位"
                            @visible-change="unitVisibleChange($event)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="ReferencePrice" title="参考售价" width="140" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">当配件商品有过报价历史时，显示配件商品的最新报价价格； <br />若配件商品从未报价给客户时，则显示配件商品的零售价格</div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 div-margin-op">
                            <el-popover :tabindex="-1" placement="top" trigger="hover" popper-class="pop-cls" :visible-arrow="false">
                                <slot>{{ row.LatestQuoteTime ? '最新报价时间：' + row.LatestQuoteTime : '无最新报价' }}</slot>
                                <el-button v-show="row.EntpTempGoodsId" slot="reference" class="b-btn" title="报价历史" @click.stop="showHistories(row.EntpTempGoodsId)"
                                    >报</el-button
                                >
                            </el-popover>
                            <el-popover
                                :tabindex="-1"
                                placement="top"
                                trigger="hover"
                                :content="row.LatestSalesTime ? '最新售价时间：' + row.LatestSalesTime : '无最新售价'"
                                popper-class="pop-cls"
                                :visible-arrow="false"
                            >
                                <el-button
                                    title="销售历史"
                                    v-show="row.EntpTempGoodsId"
                                    @click.stop="showHistoryDialog(row.EntpTempGoodsId)"
                                    slot="reference"
                                    class="s-btn"
                                    >销</el-button
                                >
                            </el-popover>
                            {{ row.ReferencePrice }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="MarketPrice" title="销售价" width="120" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">
                                当配件商品有过销售历史且该客户有购买历史时，显示该客户购买配件商品的最新销售价格； <br />若配件商品从未销售过，则不显示数值
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                <span class="color-red">*</span>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" placement="right">
                            <div slot="content">
                                利润率：{{ row.MarketPrice != 0 && row.CostPrice != 0 ? (((row.MarketPrice - row.CostPrice) / row.CostPrice) * 100).toFixed(2) : 0 }}%
                            </div>
                            <div
                                :class="[
                                    'div-padding-12',
                                    {
                                        'special-border': CheckLoseMoney(row.CostPrice, row.MarketPrice) || !row.MarketPrice
                                    }
                                ]"
                            >
                                <span
                                    :class="{
                                        'color-red': row.MarketPrice === 0 || row.MarketPrice < row.CostPrice
                                    }"
                                    >{{ row.MarketPrice }}</span
                                >
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <div
                            class="sales-input-cell"
                            v-if="(LoseMoneyValue && !dataReadonly && !(type == 8 && scope.row.WarehousedCount > 0)) || (type == 8 && priceCanBeEdit)"
                            :class="{
                                loseMoneyWarning: CheckLoseMoney(scope.row.CostPrice, scope.row.MarketPrice)
                            }"
                        >
                            <el-tooltip :disabled="!CheckLoseMoney(scope.row.CostPrice, scope.row.MarketPrice)" effect="light" placement="right">
                                <div slot="content">销售价低于成本价{{ LoseMoneyValue }}%</div>
                                <el-input-number
                                    ref="marketPirceRef"
                                    size="small"
                                    :min="0"
                                    :precision="2"
                                    :step="0.1"
                                    controls-position="right"
                                    v-model="scope.row.MarketPrice"
                                    placeholder="销售价"
                                    @input="priceChange"
                                    @change="priceCheck(scope.row)"
                                    @keyup.enter.native="keyEvent($event, 'MarketPrice')"
                                    @keyup.left.native="keyEvent($event, 'MarketPrice')"
                                    @focus="selectAutoHandle('marketPirceRef')"
                                    :disabled="!yxbPermission"
                                ></el-input-number>
                            </el-tooltip>
                        </div>
                        <div class="sales-input-cell" v-else>
                            <el-input-number
                                size="small"
                                :disabled="dataReadonly || (type == 8 && scope.row.WarehousedCount > 0) || (!priceCanBeEdit && type == 8) || !yxbPermission"
                                :min="0"
                                :precision="2"
                                :step="0.01"
                                controls-position="right"
                                v-model="scope.row.MarketPrice"
                                placeholder="销售价"
                                @input="priceChange"
                                @keyup.enter.native="addItem(true)"
                                @keyup.left.native="keyEvent($event, 'MarketPrice')"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column
                    field="BillingPrice"
                    key="BillingPrice"
                    title="开单价"
                    width="120"
                    v-if="isBPriceShow"
                    :edit-render="{ autofocus: '.el-input__inner' }"
                    resizable
                >
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.BillingPrice }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="sales-input-cell">
                            <el-input-number
                                ref="billingPriceRef"
                                size="small"
                                :min="0"
                                :precision="2"
                                :step="0.1"
                                controls-position="right"
                                v-model="scope.row.BillingPrice"
                                placeholder="开单价"
                                @input="priceChange"
                                @keyup.enter.native="keyEvent($event, 'BillingPrice')"
                                @keyup.left.native="keyEvent($event, 'BillingPrice')"
                                :disabled="dataReadonly"
                            ></el-input-number>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="xszj" title="销售总价" width="110" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ ((row.MarketPrice ? row.MarketPrice : 0) * (row.Count ? row.Count : 0)).toFixed(2) }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="ly" title="留余" width="80" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">
                                若未选定出仓仓库，显示的留余数为总库存的商品留余数； <br />若已选中出仓仓库，显示的留余数为该仓库下的商品留余数；
                                <br />注意：这里不统计退货的商品数量
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <el-tooltip
                                effect="dark"
                                :tabindex="-1"
                                :content="
                                    '待入仓(' +
                                    row.POrderWaitInQuantity +
                                    '）  待出仓(' +
                                    row.OrderWaitOutQuantity +
                                    '）  库存(' +
                                    row.StorageInventory +
                                    '）' +
                                    (isIntentShow ? '  在订数(' + (row.IntenCount ? row.IntenCount : 0) + '）' : '')
                                "
                                placement="top"
                            >
                                <div
                                    :class="{
                                        'color-red': row.StorageInventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity <= 0
                                    }"
                                >
                                    {{ row.StorageInventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity }}
                                </div>
                            </el-tooltip>
                        </div>
                    </template>
                </ux-table-column>
                <!-- 通过条件判断是否要展示的列必须添加key属性，不然会导致列表展示错了 -->
                <ux-table-column field="IsUrgent" key="IsUrgent" title="急件" width="100" v-if="isUrgentShow" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom" :tabindex="-1">
                            <div slot="content">
                                选择急件时，该商品则不再需要出仓 <br />若提交订单，该商品则自动出仓； <br />注意：若整单都为急件时，提交后则整单已出仓
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.IsUrgent ? '是' : '否' }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <div class="div-padding-12">
                            <el-checkbox
                                v-model="scope.row.IsUrgent"
                                @change="urgentchange($event, scope.row)"
                                :disabled="dataReadonly || ((scope.row.WarehousedCount > 0 && !scope.row.IsUrgent) || isPay ||scope.row.IsPur)&&type!=7"
                                @click.native.stop
                            ></el-checkbox>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="cc" title="出仓" width="90" v-if="type == 6 || type == 1" resizable>
                    <template v-slot="{ row }">
                        <el-button
                            @click="outWarehouse(row)"
                            size="mini"
                            class="search-btn btn-primary"
                            style="margin-top: 1px"
                            v-if="(permission.goodOut || permission3.saleOut) && !row.IsDelivery && type == 6 && !isForbidBatch"
                            >出仓</el-button
                        >
                        <div v-if="type == 1 || (type == 6 && isForbidBatch)" class="div-padding-12">
                            {{ row.IsDelivery ? '已出仓' : row.WarehousedCount > 0 ? '部分出仓' : '未出仓' }}
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120" v-if="type !== 6" resizable>
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate">
                            <el-button
                                size="small"
                                @click="delItem(rowIndex)"
                                icon="el-icon-delete"
                                :tabindex="-1"
                                v-if="
                                    yxbPermission &&
                                    dataList.length !== 1 &&
                                    (type == 8 ? row.WarehousedCount == 0 : !dataReadonly && (type == 2 || type == 3 || type == 4 || type == 7))
                                "
                            ></el-button>
                            <el-button
                                size="small"
                                type="primary"
                                @click="addItem(true)"
                                icon="el-icon-plus"
                                v-if="
                                    rowIndex + 1 === dataList.length && !dataReadonly && (type == 2 || type == 3 || type == 4 || type == 7 || type == 8) && yxbPermission
                                "
                            ></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
            <div class="bottom-div" @click="hideMsg">
                <div class="ship-amount" v-if="noFee">
                    运费：
                    <span class="discount-count">￥ {{ submitData.ShipAmount * 1 }}</span>
                </div>
                <div :class="['subzone', { 'no-fee': !noFee }]">
                    <div class="part">
                        <div class="dismoney">
                            <div class="distitle">
                                <el-select v-model="submitData.DiscountType" :disabled="dataReadonly || (type == 8 && hasPaid) || !yxbPermission" placeholder="请选择">
                                    <el-option v-for="item in discountOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
                                </el-select>
                            </div>
                            <el-input-number
                                v-if="submitData.DiscountType === 1"
                                size="small"
                                :disabled="dataReadonly || (type == 8 && hasPaid) || !yxbPermission"
                                v-model="submitData.DiscountAmount"
                                :min="0"
                                :step="0.01"
                                :precision="2"
                                controls-position="right"
                                :max="Number(allMoney.toFixed(2))"
                                style="width: 134px"
                            ></el-input-number>
                            <div class="percent-view" v-else-if="submitData.DiscountType === 2">
                                <el-input-number
                                    placeholder="请输入"
                                    :controls="false"
                                    :min="0"
                                    :max="100"
                                    :precision="2"
                                    :disabled="dataReadonly || (type == 8 && hasPaid) || !yxbPermission"
                                    v-model="submitData.DiscountRate"
                                ></el-input-number>
                                <span>%</span>
                            </div>
                        </div>
                    </div>
                    <div class="part">
                        <div>
                            <span style="margin: 0 12px" v-if="!noFee">=</span>
                            实收金额：
                            <span class="discount-count">￥ {{ discountCount }}</span>
                        </div>
                        <div v-if="!dataReadonly">
                            <el-button
                                size="small"
                                class="search-btn btn-primary"
                                @click.stop="submitForm(type, 0)"
                                v-if="permission.save && type != 8"
                                :disabled="saving"
                                >{{ permission.save }}</el-button
                            >
                            <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm(type, 1)" v-if="permission.submit" :disabled="saving">{{
                                permission.submit
                            }}</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--   新增客户    -->
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑客户' : '新增客户'" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :cusId="submitData.EntpCusId" :type="customerEditType" source="1" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--   财务收款    -->
        <el-dialog :close-on-click-modal="false" :title="type == 5 ? '申请收款' : '收款记录'" :visible.sync="ReceiptVisible" width="1300px">
            <div class="dialog-content" v-if="ReceiptVisible">
                <receipt ref="receipt" @closeReceipt="closeReceipt" :orderData="submitData" :type="type"></receipt>
            </div>
        </el-dialog>
        <!--   出仓     -->
        <el-dialog :close-on-click-modal="false" title="出仓" :visible.sync="outVisible" width="1000px">
            <div v-if="outVisible">
                <warehouseOut
                    :tcckType="tcckType"
                    :APList="warehouseGoodsList"
                    :OrderWarehouse="warehouseList.length > 0 ? warehouseList[0] : null"
                    :EntpCusOId="submitData.EntpCusOId"
                    @closeDialog="closeOutDialog"
                ></warehouseOut>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog
            :close-on-click-modal="false"
            title="搜索配件"
            :visible.sync="searchVisible"
            width="1248px"
            v-dialog-drag
            :modal="false"
            lock-scroll
            id="search-dialog"
        >
            <div v-if="searchVisible">
                <searchAP
                    :dragType="1"
                    dragSign="salesOrderEdit"
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="submitData.EntpCusName"
                    :StorageId="submitData.WarehouseId"
                    :Source="0"
                    :priceType="priceType"
                    :pricePoint="pricePoint"
                    :calcType="calcType"
                    :SelectedData="selectedData"
                    @chooseAllAPsHandle="chooseAllAPsHandle"
                    @closeDialog="closeSearchDialog"
                ></searchAP>
            </div>
        </el-dialog>
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
        <!--    报价历史    -->
        <el-dialog :close-on-click-modal="false" title="报价历史" :visible.sync="historyQuoteVisible" width="1200px">
            <div v-if="historyQuoteVisible">
                <APQuoteHistory
                    :EntpCusId="submitData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APQuoteHistory>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--  打印  -->
        <el-dialog :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" title="打印" :visible.sync="dialogPrintCHVisible" width="870px">
            <div class="dialog-content" v-if="dialogPrintCHVisible">
                <printContent @closePrintDialog="closePrintDialog" :printIds="idList" :printType="1" :isInit="true"></printContent>
            </div>
        </el-dialog>
        <!-- 打印隐藏内容，用于直接打印 -->
        <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important" id="printDom" v-if="isRegister">
            <printContent ref="printDom" @closeDialog="closePrintDialog" :printIds="idList" :showDisc="showDisc" :isInit="false"></printContent>
        </div>
        <!--  打印英文版  -->
        <el-dialog
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            title="打印英文销售单"
            :visible.sync="dialogPrintEngVisible"
            width="870px"
        >
            <div class="dialog-content" v-if="dialogPrintEngVisible">
                <printEngContent @closePrintDialog="closePrintDialog" :printIds="idList" :printType="1"></printEngContent>
            </div>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="dialogPrint" :close-on-click-modal="false" width="500px">
            <div style="width: 100%; height: 100%; text-align: center; margin: 25px 0px 25px 0px">
                <span style="font-size: 16px" v-if="warehouseType == 0"> <i class="el-icon-info" style="color: #67c23a"></i>是否需要提交并打印？ </span>
                <span style="font-size: 16px" v-else> <i class="el-icon-info" style="color: #67c23a"></i>是否需要提交？ </span>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" class="btnSupMini" type="primary" @click="submit(0)" :disabled="saving">提交(F1)</el-button>
                <el-button
                    size="mini"
                    class="btnSupMini"
                    type="primary"
                    @click="submit(1)"
                    v-if="warehouseType == 0 && (permission.print || permission.printPreview)"
                    :disabled="saving"
                    >提交，打印中文版(F2)</el-button
                >
                <el-button size="mini" class="btnSupMini" type="primary" @click="submit(2)" :disabled="saving" v-if="warehouseType == 0 && permission.printEng"
                    >提交，打印英文版(F3)</el-button
                >
                <el-button size="mini" class="btnSupMini" @click="canclePrint" :disabled="saving">取消</el-button>
            </span>
        </el-dialog>
        <!-- 进度条 -->
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!-- 新增和编辑物流公司 -->
        <el-dialog :close-on-click-modal="false" :title="lceParams.title" :visible.sync="lceParams.visible" width="1000px">
            <div class="dialog-content" v-if="lceParams.visible">
                <logisticsCompanyEdit ref="logisticsCompanyEdit" :compId="lceParams.id" :type="lceParams.type" @closeDialog="closeLceDialog"></logisticsCompanyEdit>
            </div>
        </el-dialog>
        <!-- 新增库存 -->
        <transInventory v-if="addAPVisible" :dialogFormVisible="addAPVisible" :apParams="addAPParams" @closeDialog="closeAddAPDialog"></transInventory>
    </div>
</template>
<script>
import Vue from 'vue';
import printEngContent from '@/components/business/salesManage/printSalesEng';
import breadcrumb from '@/components/common/breadcrumb';
import customerEdit from '@/components/business/customerManage/customerEdit';
import receipt from '@/components/business/salesManage/receipt';
import warehouseOut from '@/components/business/salesManage/warehouseOut_New';
import searchAP from '@/components/common/searchAP';
import APMsg from '@/components/common/APMsg';
import APHistory from '@/components/common/APHistory';
import APQuoteHistory from '@/components/common/APQuoteHistory';
import mixin from '@/mixins/mixin';
import logisticsCompanyEdit from '@/components/logistics/logisticsCompanyEdit';
import transInventory from '@/components/business/search/transInventory';
export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        warehouseOut,
        receipt,
        searchAP,
        APMsg,
        APHistory,
        APQuoteHistory,
        breadcrumb,
        printEngContent,
        logisticsCompanyEdit,
        transInventory
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.$refs.formMsg.resetFields();
                this.submitData = {
                    SId: this.userMsg.EmployeeId,
                    WarehouseId: '',
                    WarehouseName: '',
                    FollowerId: '',
                    SubmissionState: false,
                    EntpCusOId: '',
                    UserId: this.userMsg.EmployeeId,
                    ShipAmount: '',
                    DiscountAmount: '',
                    EntpCusId: '',
                    PayType: '',
                    ShipType: '',
                    FullAddress: '',
                    PhoneNum: '',
                    Remark: '',
                    DetailList: [],
                    LogisticId: '',
                    LogisticName: '',
                    LogisticItem: '',
                    LogisticsOrderNo: '',
                    DiscountType: 0,
                    DiscountRate: 0,
                    OrgId: '',
                    OrgName: '',
                    CusSources: '',
                    CusSourcesName: ''
                };
                this.addressList = [];
                this.allMoney = 0;
                this.allNum = 0;
                this.dataList = [];
                this.isPay = false;
                this.yxbPermission = true;
                //价格等级逻辑
                this.priceType = 0;
                this.pricePoint = 1;
                this.calcType = -1;
                this.init();
            }
        }
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            isCheckCode: true,
            userMsg: userMsg,
            idList: [],
            addressList: [],
            postType: 0,
            dialogPrintCHVisible: false,
            dialogPrintEngVisible: false,
            dialogPrint: false,
            needConfirm: true,
            SIdList: [
                {
                    EmployeeId: userMsg.EmployeeId,
                    EmployeeName: userMsg.EmployeeName
                }
            ],
            FollowerList: [],
            EntpTempGoodsIdEdit: '',
            loading: false,
            saving: false,
            warehouseType: 0,
            dataReadonly: false,
            showOrderMsg: true,
            APMsgVisible: false,
            historyVisible: false,
            searchVisible: false,
            ReceiptVisible: false,
            dialogVisible: false,
            outVisible: false,
            historyQuoteVisible: false,
            isIntentShow: false,
            allNum: 1,
            allMoney: 0,
            customerEditType: 1,
            submitData: {
                SId: userMsg.EmployeeId,
                WarehouseId: '',
                WarehouseName: '',
                FollowerId: '',
                SubmissionState: false,
                EntpCusOId: '',
                UserId: userMsg.EmployeeId,
                ShipAmount: '',
                DiscountAmount: '',
                EntpCusId: '',
                PayType: '',
                ShipType: '',
                FullAddress: '',
                PhoneNum: '',
                Remark: '',
                DetailList: [],
                LogisticId: '',
                LogisticName: '',
                LogisticItem: '',
                LogisticsOrderNo: '',
                DiscountType: 0,
                DiscountRate: 0,
                OrgId: '',
                OrgName: '',
                CusSources: '',
                CusSourcesName: ''
            },
            Limit: 10,
            customerList: [],
            DeliveryMethodList: [], // 发货方式列表
            payWayList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            dataList: [],
            unitList: [],
            warehouseList: [], //仓库列表
            warehouseGoodsList: [], //入库商品列表
            type: 1, //  1 查看 2 编辑 3 新增 4 从库存配件管理过来的
            id: '',
            pageTitle: '',
            rules: {
                ShipType: [
                    {
                        required: true,
                        message: '请选择发货方式',
                        trigger: 'change'
                    }
                ],
                EntpCusId: [
                    {
                        required: true,
                        message: '请选择客户',
                        trigger: 'change'
                    }
                ],
                SId: [
                    {
                        required: true,
                        message: '请选择业务员',
                        trigger: 'change'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        message: '填写电话号码',
                        trigger: 'change'
                    }
                ],
                FullAddress: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'change'
                    }
                ],
                PayType: [
                    {
                        required: true,
                        message: '填写结算方式',
                        trigger: 'change'
                    }
                ],
                ShipAmount: [
                    {
                        validator: checkPositive,
                        trigger: 'blur'
                    }
                ],
                WarehouseId: [{ required: true, message: '请选择仓库', trigger: 'change' }],
                OrgId: [{ required: true, message: '请选择部门', trigger: 'change' }],
                CusSources: [
                    {
                        required: true,
                        message: '请选择来源',
                        trigger: 'change'
                    }
                ]
            },
            permission: {},
            permission2: {},
            permission3: {},
            funcConfig: false,
            discountOptions: [
                { id: 0, value: '无优惠' },
                { id: 1, value: '优惠金额' },
                { id: 2, value: '整单优惠' }
            ],
            LoseMoneyValue: 0, //亏本指标
            priceCanBeZero: false,
            priceCanBeEdit: false,
            changeCodeConfig: false,
            isInvenShow: false,
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            isSSetConfig: false,
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            logisticsList: [],
            yxbPermission: true, //修改订单时，只有易询宝付款后的订单能修改物流数据，其他都不能动
            apcodeSource: null, // 用于处理取消编码请求操作
            // 用于客户名称列表，分页搜索
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于配件名称列表，分页搜索功能
            nameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于车型列表，分页搜索功能
            autoSerieForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: false,
            // 汽配编码排序标识
            sortActive: '',
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            // 功能配置项：初始数量值
            initNumber: 1,
            // 新增和编辑物流公司参数
            lceParams: {
                id: '',
                type: 1, // 1 新增，2 编辑
                title: '',
                visible: false
            },
            // 提交后是否展示到下次订单中？
            customerChecked: false,
            saveCustomerCache: false,
            //留余是否计算待入数据
            //否：留余数=库存数-待出库数
            //是：留余数=库存数-待出库数+待入库数
            isAddWaitIn: true,
            // 整单出仓，弹框模式，1 同仓出库，0 单个出仓
            tcckType: 0,
            // 新增库存
            addAPVisible: false,
            addAPParams: {},
            isBPriceShow: false, //开单价
            isOrgShow: false, //开单部门
            isLastOrg: false,
            oldOrderId: '',
            isOriginShow: false, //显示产地
            orgList: [], //
            askShowDisc: false, //询问是否打印订单优惠价格
            isDefaultSet: false, //是否使用浏览器的打印功能
            isPreview: false, //是否出现预览界面
            isRegister: false,
            showDisc: false,
            pricePoint: 1,
            priceType: 0,
            calcType: -1,
            IsNoZeroGoods: false, //是否禁止添加库存为零的商品
            isForbidBatch: false,
            isUseSource: false, //是否启用销售开单显示来源
            cusSourcesList: [],
            isCheckPriceCS: false, //检查销售价的低于成本价
            isUrgentShow: false, //急件
            isPay: false, //是否财务确认
            isDefaultWH: false ,//是否默认上一次开单的仓库
            submitStorageName:'salesOrder',
            dataStorageName:'salesOrder_dataList',
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.removeEventListener('keydown', this.handleKeyEvent);
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getSendWay();
        this.getPay();
    },
    mounted() {
        let that = this;
        that.init();
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
        // 监听滚动事件
        window.onresize = () => {
            that.resetHeight();
        };
        //加载组件
        that.getPrintComponents();
    },
    computed: {
        noFee() {
            return this.submitData.ShipAmount && this.submitData.ShipAmount * 1 !== 0;
        },
        // 优惠后的金额
        discountCount() {
            let discountCount = this.submitData.DiscountAmount;
            let shipAmount = this.submitData.ShipAmount ? this.submitData.ShipAmount * 1 : 0;

            if (this.submitData.DiscountType === 2) {
                // 处理整单优惠
                discountCount = (this.submitData.DiscountRate / 100) * this.allMoney;
            }
            if (!discountCount || this.submitData.DiscountType === 0) {
                return (this.allMoney * 1 + shipAmount).toFixed(2);
            }
            return (this.allMoney * 1 - discountCount + shipAmount > 0 ? this.allMoney * 1 - discountCount + shipAmount : 0).toFixed(2);
        },
        // 当type为6时定义新样式
        infiniteListClass() {
            return +this.type === 6 ? 'infinite-list-special-class' : '';
        },
        // 列表高度，当type为6时高度自适应
        infiniteTableHeight() {
            let bottomHeight = this.noFee ? 158 : 78;
            let resultHeight = this.infiniteListHeight - bottomHeight;
            return +this.type === 6 ? 'auto' : resultHeight;
        },
        // 是否加锁
        isLock() {
            return this.hasLock && [2, 3, 8].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        },
        // 收款金额是否大于零，当为true时，不能修改优惠金额
        hasPaid() {
            return this.submitData.Paid && this.submitData.Paid * 1 > 0;
        },
        // 是否新增，编辑，修改
        isEdit() {
            return [2, 3, 8].includes(this.type * 1);
        }
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            if (that.dataReadonly) return;
            //打印弹窗
            if (this.dialogPrintCHVisible || this.dialogPrintEngVisible) {
                e.preventDefault();
                return;
            }
            let key = window.event.keyCode;
            //提交订单后的提示弹窗的按钮事件
            if (that.dialogPrint) {
                e.preventDefault();
                // 提交(F1)
                if (key == 112) that.submit(0);
                // 提交，打印中文版(F2)
                else if (key == 113 && that.warehouseType == 0 && (that.permission.print || that.permission.printPreview)) that.submit(1);
                // 提交并自动打印(F3)
                else if (key == 114 && that.warehouseType == 0 && that.permission.printEng) that.submit(2);

                return;
            }
            if (key === 107 || key === 187) {
                if (!this.searchVisible) this.addItem(false);
            }
            if (key == 113) {
                this.searchVisible = true;
            }
        },
        //获取中文打印模板
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                    that.isRegister = true;
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printSales'));
                    that.isRegister = true;
                }
            });
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'kdbjsd',
                    'ddhhm',
                    'sjqx',
                    'kdyjz',
                    'xsgdy',
                    'xskbzb',
                    'xsspjgwl',
                    'xgxsjg',
                    'lybsdr',
                    'syztsj',
                    'ddkcs',
                    'xskdxskdj',
                    'xskdxskdbm',
                    'kdbmmrsycxz',
                    'xwdyxxdxxyh',
                    'syllqdysz',
                    'dyyl',
                    'kdspcd',
                    'xskdjzkcl',
                    'xzxsjkqbcc',
                    'xsddly',
                    'xzqpbmdwyx',
                    'spsjbdycb',
                    'xsdbsjj',
                    'xskdmrck'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'kdbjsd':
                                    this.hasLock = result;
                                    break;
                                case 'ddhhm':
                                    this.changeCodeConfig = result;
                                    break;
                                case 'sjqx':
                                    this.isSSetConfig = result;
                                    break;
                                case 'kdyjz':
                                    this.isPreloadApCodeList = result;
                                    break;
                                case 'xsgdy':
                                    this.funcConfig = result;
                                    break;
                                case 'xskbzb':
                                    this.LoseMoneyValue = result ? Number(rValue) : 0;
                                    break;
                                case 'xsspjgwl':
                                    this.priceCanBeZero = result;
                                    break;
                                case 'xgxsjg':
                                    this.priceCanBeEdit = result;
                                    break;
                                case 'lybsdr':
                                    this.isAddWaitIn = !result;
                                    break;
                                case 'syztsj':
                                    this.isIntentShow = result;
                                    break;
                                case 'ddkcs':
                                    this.isInvenShow = result;
                                    break;
                                case 'xskdxskdj':
                                    this.isBPriceShow = result;
                                    break;
                                case 'xskdxskdbm':
                                    this.isOrgShow = result;
                                    break;
                                case 'kdbmmrsycxz':
                                    this.isLastOrg = result;
                                    break;
                                case 'xwdyxxdxxyh': //询问是否打印订单优惠价格
                                    this.askShowDisc = result;
                                    break;
                                case 'syllqdysz': //是否使用浏览器的打印功能
                                    this.isDefaultSet = result;
                                    break;
                                case 'dyyl': //是否出现预览界面
                                    this.isPreview = result;
                                    break;
                                case 'kdspcd': //产地
                                    this.isOriginShow = result;
                                    break;
                                case 'khgzzq': //开启挂账限制
                                    this.isCheckCredit = result;
                                    break;
                                case 'xskdjzkcl': //禁止添加库存为零的商品
                                    this.IsNoZeroGoods = result;
                                    break;
                                case 'xzxsjkqbcc': //限制分批出仓
                                    this.isForbidBatch = result;
                                    break;
                                case 'xsddly': //是否启用销售开单显示来源
                                    this.isUseSource = result;
                                    break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'spsjbdycb': //开启检查销售价的低于成本价限制
                                    this.isCheckPriceCS = result;
                                    break;
                                case 'xsdbsjj': //展示急件
                                    this.isUrgentShow = result;
                                    break;
                                case 'xskdmrck': //是否默认上一次开单的仓库
                                    this.isDefaultWH = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        // 关闭新增库存弹框
        async closeAddAPDialog(result, row) {
            this.addAPVisible = false;
            if (!row) return;
            this.$set(this.dataList, this.addAPParams.index, {
                ...row,
                Count: this.initNumber,
                // 是否可编辑，用于报价转销售情况时新增数据情况
                canEdit: this.type == 4,
                State: 0,
                StorageInventory: 0,
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0
            });
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        // 新增和编辑物流公司
        lceHandle(type) {
            this.lceParams = {
                id: type === 2 ? this.submitData.LogisticId : '',
                type,
                title: `${type === 2 ? '编辑' : '新增'}物流公司`,
                visible: true
            };
        },
        // 关闭物流弹框
        closeLceDialog(edit) {
            this.lceParams.visible = false;
            if (edit) {
                this.submitData.LogisticId = '';
                this.submitData.LogisticItem = '';
                this.searchLogistic();
            }
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        async init() {
            this.permission = this.$util.getPermission('salesOrder');
            this.permission3 = this.$util.getPermission('salesOrderTakeOut');

            this.id = this.$route.query.id;
            this.submitData.EntpCusOId = this.$route.query.id;
            this.type = Number(this.$route.query.type);

            if(this.type==3){
                this.submitStorageName=this.submitStorageName+'_add';
                this.dataStorageName=this.dataStorageName+'_add';                
            } else if(this.type==7){
                this.submitStorageName=this.submitStorageName+'_copy';
                this.dataStorageName=this.dataStorageName+'_copy';                
            }else if(this.type==4){
                this.submitStorageName=this.submitStorageName+'_trans';
                this.dataStorageName=this.dataStorageName+'_trans';                
            }else if(this.type==9){
                this.submitStorageName=this.submitStorageName+'_purtrans';
                this.dataStorageName=this.dataStorageName+'_purtrans';                
            }
            let salesOrderModel = this.$util.getLocalStorage(this.submitStorageName);
            let datalist = this.$util.getLocalStorage(this.dataStorageName);

            await this.$util.GetEntpCache({ CacheKey: 'salesOrder_saveCustomerCache' }, true).then(data => {
                if (data) {
                    this.saveCustomerCache = JSON.parse(data);
                }
            });
            switch (this.type) {
                case 1:
                    this.pageTitle = '查看销售单';
                    this.dataReadonly = true;
                    this.getConfigByCodes().then(() => {
                        this.getOrderDetail();
                    });
                    break;
                case 2:
                    this.pageTitle = '编辑销售单';
                    await this.getConfigByCodes().then(() => {
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace();
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getOrderDetail();
                        }
                    });
                    break;
                case 3:
                    this.pageTitle = '新增销售单';
                    await this.getConfigByCodes().then(() => {
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace().then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                        } else {
                            //判断是否从我的网销商品页面过来
                            let siGoodsIds = this.$util.getLocalStorage('SI_GoodsData');
                            if (siGoodsIds) {
                                this.$util.clearLocalStorage('SI_GoodsData');
                                this.pageTitle = '转为销售单';
                                this.getDataByGoodsIds(siGoodsIds);
                            } else {
                                this.addItem(false);
                                this.getdefaultWarehouses();
                            }
                            if (this.isOrgShow && this.isLastOrg) {
                                this.getLastOrderOrgId();
                            }
                        }
                    });
                    break;
                case 4:
                    this.pageTitle = '转为销售单';
                    await this.getConfigByCodes().then(() => {
                        //判断缓存是否有数据，如果有取缓存数据
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace().then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getBJOrder();
                            if (this.isOrgShow && this.isLastOrg) {
                                this.getLastOrderOrgId();
                            }
                        }
                    });
                    break;
                case 5:
                    this.needConfirm = false;
                    this.pageTitle = '财务收款';
                    this.getConfigByCodes().then(() => {
                        this.getOrderDetail();
                    });
                    break;
                case 6:
                    this.needConfirm = false;
                    this.pageTitle = '货物出仓';
                    this.getConfigByCodes().then(() => {
                        this.getOrderDetail();
                    });
                    break;
                case 7:
                    this.pageTitle = '复制订单';
                    await this.getConfigByCodes().then(() => {
                        //判断缓存是否有数据，如果有取缓存数据
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace();
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getOrderDetail();
                        }
                    });
                    break;
                case 8:
                    this.pageTitle = '修改订单';
                    await this.getConfigByCodes().then(() => {
                        //判断缓存是否有数据，如果有取缓存数据
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace();
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getOrderDetail();
                        }
                    });
                    break;
                case 9:
                    this.pageTitle = '采购转销售单';
                    this.submitData.QuoteId = this.$route.query.pid;
                    await this.getConfigByCodes().then(() => {
                        //判断缓存是否有数据，如果有取缓存数据
                        if (salesOrderModel || (datalist && datalist.length > 0)) {
                            this.getDataFromChace().then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                            this.submitData.EntpCusOId = this.id;
                        } else {
                            this.getOrderforSales().then(() => {
                                if (this.isOrgShow && this.isLastOrg && !this.submitData.OrgId) {
                                    this.getLastOrderOrgId();
                                }
                            });
                        }
                    });
                    break;
                default:
                    break;
            }

            if (!this.submitData.FollowerId && this.funcConfig) {
                this.getSalesOrderFollower();
            }

            setTimeout(() => {
                this.resetHeight();
            }, 0);
        },
        refresh() {
            this.$router.replace({
                path: '/salesManage/salesOrder/edit_v2',
                query: { id: '', type: 3, _t: Date.now() }
            });
            this.saving = false;
        },
        refreshTable() {
            this.$router.back(-1);
            this.saving = false;
        },
        closePrintDialog(action) {
            this.dialogPrint = false;
            this.dialogPrintCHVisible = false;
            this.dialogPrintEngVisible = false;
            // if (isprint == null) {
            //     this.refresh();
            // } else {
            //     this.refreshTable();
            // }
            //打印并继续开单
            if (action == 'continueToOrder') {
                setTimeout(() => {
                    // if (that.type != 0) that.refresh(); //这刷新方式如果是新增订单时不起作用，应该是参数没有发生变化导致
                    // else that.$router.go(0);//编辑订单时无法清空路由的参数
                    this.refresh();
                }, 1000);
            } else {
                //打印并返回列表或者直接返回列表
                setTimeout(() => {
                    this.$router.push('/salesManage/salesOrder');
                }, 1000);
            }
        },
        canclePrint() {
            this.dialogPrint = false;
        },
        getSIdList() {
            if (this.isSSetConfig) {
                this.$util.getAuthSIdList().then(data => {
                    this.SIdList = data;
                });
                this.$util.getSIdList().then(data => {
                    this.FollowerList = data;
                });
            } else {
                this.$util.getSIdList().then(data => {
                    this.SIdList = data;
                    this.FollowerList = data;
                });
            }
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            if (this.dataList.length > 0) {
                this.selectedData = [];
                this.dataList.forEach(item => {
                    if (item.EntpTempGoodsId) this.selectedData.push(item.EntpTempGoodsId);
                });
            }
            this.searchVisible = true;
        },
        //从缓存中读取上次开单的部门
        getLastOrderOrgId() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                if (this.orgList.length == 0) {
                    this.$util.getParentOrgs().then(data => {
                        this.orgList = data;
                        this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                            if (result) {
                                let orgdata = JSON.parse(result);
                                if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                    this.submitData.OrgId = orgdata.OrgId;
                                    this.submitData.OrgName = orgdata.OrgName;
                                }
                            }
                            resolve();
                        });
                    });
                } else
                    this.$util.GetEntpCache({ CacheKey: 'LastOrderOrg', CacheType: '1' }, true).then(result => {
                        if (result) {
                            let orgdata = JSON.parse(result);
                            if (this.orgList.findIndex(f => f.Id == orgdata.OrgId) > -1) {
                                this.submitData.OrgId = orgdata.OrgId;
                                this.submitData.OrgName = orgdata.OrgName;
                            }
                        }
                        resolve();
                    });
            });
        },
        // 搜索配件弹框 - 确认筛选结果按钮操作
        chooseAllAPsHandle(data) {
            this.searchVisible = false;
            if (!this.yxbPermission) {
                return;
            }
            data.searchData.CheckSalesOutWHCout = false;
            this.searchApParams = {
                ...data.searchData,
                limit: this.searchApParams._limit,
                _visible: true,
                _percentage: 0,
                _limit: this.searchApParams._limit,
                _totalCount: data.searchData.limit
            };
            this.loopSearch();
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpGoods/GetFullDataGoodsListForOrder',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            this.searchApParams.page += 1;
            let _stop = !data || data.length < this.searchApParams._limit;
            this.closeSearchDialog(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        // 搜索配件弹框 - 关闭弹框并更新页面数据
        closeSearchDialog(items, noClose = false) {
            let that = this;
            let itemList = [...items];
            if (!that.yxbPermission || itemList.length == 0) {
                if (!noClose) {
                    that.searchVisible = false;
                    return;
                }
            }

            let ischeck = false;
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                if (that.isCheckPriceCS && !ischeck) {
                    let checkval = item._price < item.CostPrice;
                    if (checkval) {
                        ischeck = true;
                        that.$util.warningMsg('当前销售价格已经低于成本价，请确认！');
                    }
                }

                let isExist = false;
                that.dataList.forEach((e, index) => {
                    if (item.APCode == e.APCode) {
                        isExist = true;
                        e.StorageInventory = item.StorageInventory;
                        e.MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                    }
                });
                if (!isExist) {
                    let newGoods = {
                        ReferencePrice: item.ReferencePrice,
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        GoodNameItem: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: this.initNumber,
                        MarketPrice: item.LatestPrice > 0 ? item.LatestPrice : '',
                        Unit: item.Unit,
                        Remark: '',
                        CodeRepeat: false,
                        Inventory: item.Inventory,
                        StorageInventory: item.StorageInventory,
                        WarehousedCount: 0,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        LatestSalesTime: item.LatestSalesTime,
                        LatestQuoteTime: item.LatestQuoteTime,
                        State: 0,
                        // 是否可编辑，用于报价转销售情况时新增数据情况
                        canEdit: this.type == 4,
                        IntenCount: item.IntenCount,
                        CostPrice: item.CostPrice,
                        BillingPrice: item.MarketPrice == 0 ? '' : item.MarketPrice,
                        MainImage: item.MainImage,
                        Origin: item.Origin,
                        IsUrgent: false
                    };
                    if (!isNaN(item._count)) {
                        newGoods.Count = item._count;
                    }
                    if (!isNaN(item._price)) {
                        newGoods.MarketPrice = item._price;
                    }
                    newGoodsList.push(newGoods);
                }
                // 重复数据并且从搜索配件双击回来时修改数量和销售价
                if (noClose && isExist) {
                    let fIdx = that.dataList.findIndex(f => f.APCode === item.APCode);
                    if (fIdx > -1) {
                        that.dataList[fIdx].Count = item._count;
                        that.dataList[fIdx].MarketPrice = item._price;
                    }
                }
            }
            //判断最后一条数据是否空值，是的话移到最后，noClose 表示不关闭弹框
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            that.priceChange();
            if (!noClose) {
                that.searchVisible = false;
            }
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 历史销售
        showHistoryDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
            this.historyQuoteVisible = false;
        },
        showHistories(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyQuoteVisible = true;
            }
        },
        // 出仓
        outWarehouse(item) {
            this.warehouseGoodsList = [];
            if (item) {
                this.warehouseGoodsList.push({ ...item }); // 单个入仓
                this.tcckType = 0;
            } else {
                this.warehouseGoodsList = [...this.dataList]; // 整单入仓
                this.tcckType = 1;
            }
            this.outVisible = true;
        },
        closeOutDialog(edit, IsAllOutWarehouse) {
            this.outVisible = false;
            this.needConfirm = false;
            if (IsAllOutWarehouse) {
                this.$store.commit('updateNeedRefresh', true);
                window.history.go(-1);
                return;
            }
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        showMsg() {
            this.showOrderMsg = true;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].MarketPrice ? (DetailList[i].Count * DetailList[i].MarketPrice).toFixed(3) : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            // this.dataList = DetailList;
        },
        priceCheck(row) {
            let that = this;
            if (that.isCheckPriceCS) {
                let price = row.MarketPrice;
                let checkval = Number(price) < row.CostPrice;
                if (checkval) {
                    that.$util.warningMsg('当前销售价格已经低于成本价，请确认！');
                }
            }
        },
        // 显示收款
        showReceipt() {
            this.ReceiptVisible = true;
        },
        // 隐藏收款
        closeReceipt(edit, IsAllCollect) {
            this.ReceiptVisible = false;
            this.needConfirm = false;
            if (IsAllCollect) {
                this.$store.commit('updateNeedRefresh', true);
                window.history.go(-1);
                return;
            }
            if (edit) {
                this.getOrderDetail();
            }
        },
        // closeDialog(edit) {
        //     this.dialogVisible = false;
        //     if (edit) {
        //         this.searchCustomer();
        //     }
        // },
        closeDialog(edit, entpCusId, entpCusName) {
            let that = this;
            if (edit != 'edit') {
                if (edit == 'used' && entpCusId) {
                    that.submitData.EntpCusId = entpCusId;
                    if (!that.submitData.EntpCusName) that.submitData.EntpCusName = entpCusName;
                    that.getDefaultData();
                } else that.searchCustomer();
            } else if (edit == 'edit' && entpCusId) {
                if (entpCusId == that.submitData.EntpCusId) {
                    that.getDefaultData();
                }
            }
            that.dialogVisible = false;
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogVisible = true;
        },
        // 报价单转销售单详情
        getBJOrder() {
            this.getdefaultWarehouses();
            this.$util
                .axiosGet({
                    url: '/api/EntpQuotationOrder/GetQuotationOrderToSaleOrder',
                    data: {
                        QuoteId: this.id,
                        EntpId: this.userMsg.EntpId,
                        WarehouseId: this.submitData.WarehouseId
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;

                    this.submitData.QuoteId = this.id;
                    this.submitData.UserId = this.userMsg.EmployeeId;
                    this.submitData.EntpCusId = data.EntpCusId;
                    this.submitData.EntpCusName = data.EntpCusName;
                    this.submitData.PhoneNum = data.PhoneNum;
                    this.submitData.FullAddress = data.FullAddress;
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        DetailList[i].BillingPrice = DetailList[i].MarketPrice == 0 ? '' : DetailList[i].MarketPrice;
                    }
                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                    if (data.Warehouse) {
                        this.warehouseList = [];
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Address: data.Warehouse.Address,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                    this.getDefaultData();
                });
        },
        //采购转销售
        getOrderforSales() {
            return new Promise(resolve => {
                this.getdefaultWarehouses();
                this.$util
                    .axiosGet({
                        url: '/api/EntpPurchaseOrder/GetOrderforSales',
                        data: {
                            EntpCusPOId: this.submitData.QuoteId
                        }
                    })
                    .then(res => {
                        let data = res.data;
                        let DetailList = data.DetailList;

                        let _allNum = 0;
                        let _allMoney = 0;
                        for (let i = 0; i < DetailList.length; i++) {
                            _allNum += Number(DetailList[i].Count);
                            _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                            DetailList[i].GoodNameItem = DetailList[i].GoodName;
                            DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        }
                        this.allMoney = _allMoney;
                        this.allNum = _allNum;
                        this.dataList = DetailList;
                        if (data.Warehouse) {
                            this.warehouseList = [];
                            this.warehouseList.push({
                                WarehouseId: data.Warehouse.WarehouseId,
                                WarehouseName: data.Warehouse.WarehouseName,
                                Address: data.Warehouse.Address,
                                Type: data.Warehouse.WarehouseType
                            });
                            this.warehouseType = data.Warehouse.WarehouseType;
                            this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                            this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                            this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                        }
                        this.getDefaultData();
                    })
                    .finally(() => {
                        this.loading = false;
                        resolve();
                    });
            });
        },
        //根据商品id获取销售单商品
        getDataByGoodsIds(ids) {
            let that = this;
            this.getdefaultWarehouses();
            that.$util
                .axiosPost({
                    url: '/api/EntpGoods/GetDataByGoodsIds',
                    data: {
                        sId: that.submitData.WarehouseId,
                        ids: ids
                    }
                })
                .then(res => {
                    let DetailList = res.data;
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        DetailList[i].hasLock = this.hasLock;
                    }

                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                })
                .catch(() => {});
        },
        // 获取详情
        getOrderDetail() {
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/GetEntpCusSaleOrder',
                    data: {
                        EntpCusOId: this.id,
                        Type: this.type
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    data.SubmissionState = Boolean(data.SubmissionState);
                    data.UserId = this.userMsg.EmployeeId;
                    data.LogisticItem = data.LogisticName;

                    if (this.type == 8 && data.Sources == 4 && data.IsPay) {
                        this.yxbPermission = false;
                    }
                    // 判断是否可编辑
                    if (this.type != 2 && this.type != 3 && this.type != 7 && this.type != 8) {
                        this.dataReadonly = true;
                    }
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName,
                        CallNum: data.PhoneNum,
                        FullAddress: data.FullAddress
                    });

                    let i = this.SIdList.findIndex(item => {
                        if (item.EmployeeId == data.SId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        this.SIdList.push({
                            EmployeeId: data.SId,
                            EmployeeName: data.SName
                        });
                    }
                    this.FollowerList.push({
                        EmployeeId: res.data.FollowerId,
                        EmployeeName: res.data.FollowerName
                    });
                    if (this.isOrgShow && res.data.OrgId) {
                        this.oldOrderId = res.data.OrgId;
                        this.orgList.push({ Id: data.OrgId, Name: data.OrgName });
                    }
                    if (this.isUseSource && data.CusSources) {
                        this.cusSourcesList = [];
                        this.cusSourcesList.push({ Text: data.CusSourcesName, Value: data.CusSources });
                    }

                    this.submitData = data;
                    if (!this.submitData.SId) this.submitData.SId = this.userMsg.EmployeeId;

                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Address: data.Warehouse.Address,
                            Type: data.Warehouse.Type
                        });
                        this.warehouseType = data.Warehouse.Type;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.Type);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    } else {
                        this.getdefaultWarehouses();
                    }

                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        this.$set(DetailList[i], 'MarketPrice', DetailList[i].Price);
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].MarketPrice ? DetailList[i].Count * DetailList[i].MarketPrice : 0;
                        DetailList[i].GoodNameItem = DetailList[i].GoodName;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                        DetailList[i].hasLock = this.hasLock;

                        if (this.type == 7) {
                            DetailList[i].WarehousedCount = 0;
                        }
                    }

                    //价格等级逻辑
                    this.priceType = data.PriceType;
                    this.pricePoint = data.PricePoint;
                    this.calcType = data.CalcType;
                    this.isPay = data.IsPay;

                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                });
        },
        // 提交销售单
        submitForm(type, SubmissionState) {
            this.$refs.formMsg.validate(valid => {
                if (valid) {
                    let _dataList = this.dataList;
                    if (!this.submitData.EntpCusId && this.type != 4) {
                        this.$util.warningMsg('请选择客户');
                        this.showMsg();
                        return;
                    }
                    if (!this.submitData.FullAddress) {
                        this.$util.warningMsg('请输入客户收货地址');
                        this.showMsg();
                        return;
                    }
                    if (this.submitData.LogisticsOrderNo && !this.submitData.LogisticId) {
                        this.$util.warningMsg('请选择物流公司，否则物流单号将无法保存');
                        this.showMsg();
                        return;
                    }
                    if (this.submitData.DiscountType === 2) {
                        // 处理整单优惠
                        this.submitData.DiscountAmount = (this.submitData.DiscountRate / 100) * this.allMoney;
                    }
                    if (this.submitData.DiscountAmount > this.allMoney) {
                        this.$util.warningMsg('优惠金额不能大于订单总额');
                        return;
                    }
                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                            return;
                        }
                        if (!_dataList[i].AutoSerise) {
                            this.$util.warningMsg('请填写车型');
                            return;
                        }
                        if (!_dataList[i].Count || _dataList[i].Count < 0) {
                            this.$util.warningMsg('请填写正确的数量');
                            return;
                        } else {
                            if (!_dataList[i].IsDelivery && _dataList[i].WarehousedCount > 0 && _dataList[i].Count < _dataList[i].WarehousedCount) {
                                this.$util.warningMsg('商品数量不能少于已出仓数，已出仓' + _dataList[i].WarehousedCount + '个商品');
                                return;
                            }
                        }
                        if (!_dataList[i].Unit) {
                            this.$util.warningMsg('请填写单位');
                            return;
                        }
                        if (!this.priceCanBeZero && !_dataList[i].MarketPrice) {
                            this.$util.warningMsg('销售价不能小于0');
                            return;
                        }
                        if (!this.priceCanBeZero) {
                            if (!_dataList[i].MarketPrice && !_dataList[i].Price) {
                                this.$util.warningMsg('请填写销售价');
                                return;
                            }
                            if (_dataList[i].MarketPrice == 0) {
                                this.$util.warningMsg('销售价不能为0');
                                return;
                            }
                        }

                        if (_dataList[i].MarketPrice >= 0) {
                            _dataList[i].Price = _dataList[i].MarketPrice;
                        }
                        if (this.isBPriceShow) {
                            if (_dataList[i].BillingPrice && _dataList[i].BillingPrice <= 0) {
                                this.$util.warningMsg('开单价不能小于等于0');
                                return;
                            }
                        }
                        let msg = '第' + (i + 1) + '项商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】';
                        if (this.IsNoZeroGoods && SubmissionState == 1) {
                            if (_dataList[i].StorageInventory == 0) {
                                this.$util.warningMsg(`${msg}当前库存商品为零,不可提交订单`);
                                return;
                            }
                        }
                    }

                    this.postType = type;
                    this.submitData.DetailList = _dataList;
                    this.submitData.SubmissionState = SubmissionState;

                    let checkRepeat = this.checkRepeatAndReturnData();
                    if (checkRepeat.hasRepeat) {
                        this.$confirm('订单含有重复商品项，是否需要累加', '', {
                            type: 'error',
                            distinguishCancelAndClose: true
                        })
                            .then(() => {
                                // 覆盖数据
                                this.dataList = checkRepeat.row;
                                this.submitData.DetailList = checkRepeat.row;
                                this.submitBefore(SubmissionState);
                            })
                            .catch(() => {});
                    } else {
                        this.submitBefore(SubmissionState);
                    }
                } else {
                    this.$util.warningMsg('有必填项未填写');
                    this.showMsg();
                }
            });
        },
        // 提交前确认
        submitBefore(SubmissionState) {
            switch (SubmissionState) {
                case 0: //保存
                    this.submit(0); //不打印
                    break;
                case 1: //提交
                    this.dialogPrint = true;
                    break;
            }
        },
        submit(printType) {
            let that = this;
            if (that.saving) return;
            that.saving = true; //防止多次点击
            that.dialogPrint = false;

            let type = Number(that.postType);
            let url = '';
            switch (type) {
                case 2: // 2 是编辑（未提交前）；
                    url = '/api/EntpSaleOrder/Save';
                    break;
                case 3: // 3 是新增；
                    url = '/api/EntpSaleOrder/Save';
                    break;
                case 8: // 8 是修改（提交后）
                    url = '/api/EntpSaleOrder/SaveAfterSubmit';
                    break;
                case 7: // 7 是重新开单
                    url = '/api/EntpSaleOrder/RebuildSaleOrder';
                    break;
                case 9: //采购转销售
                    url = '/api/EntpSaleOrder/TransformPurOrder';
                    break;
                default:
                    //4 报价转为销售单
                    url = '/api/EntpSaleOrder/TransformQuotationOrder';
                    break;
            }
            that.$util
                .axiosPost({
                    url: url,
                    data: that.submitData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.needConfirm = false;

                        that.idList = [];
                        if (res.data) {
                            //新增
                            that.idList.push(res.data);
                            that.submitData.EntpCusOId = res.data;
                        } else {
                            //修改
                            that.idList.push(that.id);
                        }

                        if (type == 2 || type == 3 || type == 7) {
                            let name = '';
                            switch (that.submitData.SubmissionState) {
                                case 0:
                                    name = '保存';
                                    break;
                                case 1:
                                    name = '提交';
                                    break;
                            }
                            that.$util.successMsg(name + '销售订单成功');
                        } else if (type == 8) {
                            that.$util.successMsg('修改销售订单成功');
                        } else {
                            that.$util.successMsg('转为销售订单成功');
                        }
                        //清除销售订单缓存
                        that.removePageChace();

                        let CacheList = [];
                        //添加默认出仓仓库
                        if (that.submitData.WarehouseId) {
                            var wd = {
                                WarehouseId: that.submitData.WarehouseId,
                                WarehouseName: that.submitData.WarehouseName,
                                WarehouseType: that.warehouseType
                            };
                            CacheList.push({ CacheKey: 'defaultOutWarehouses', CacheValue: JSON.stringify(wd), CacheType: '1' });
                        }

                        //添加默认部门
                        if (
                            that.isOrgShow &&
                            that.isLastOrg &&
                            that.submitData.OrgId &&
                            (that.type == 2 ||
                                that.type == 3 ||
                                that.type == 4 ||
                                that.type == 7 ||
                                that.type == 9 ||
                                ((that.type == 2 || that.type == 8) && that.oldOrderId != that.submitData.OrgId))
                        ) {
                            var og = {
                                OrgId: that.submitData.OrgId,
                                OrgName: that.submitData.OrgName
                            };
                            CacheList.push({ CacheKey: 'LastOrderOrg', CacheValue: JSON.stringify(og), CacheType: '1' });
                        }

                        if (that.submitData.FollowerId && that.funcConfig) {
                            if (that.funcConfig) {
                                let fo = that.FollowerList.filter(f => f.EmployeeId == that.submitData.FollowerId);
                                if (fo) {
                                    var follower = {
                                        FollowerId: that.submitData.FollowerId,
                                        FollowerName: fo[0].EmployeeName
                                    };
                                    CacheList.push({ CacheKey: 'salesOrder_follower', CacheValue: JSON.stringify(follower) });
                                }
                            }
                        }

                        // 添加缓存：提交后是否展示到下次订单中
                        CacheList.push({ CacheKey: 'salesOrder_saveCustomerCache', CacheValue: that.customerChecked });

                        that.$util.SetEntpCache(CacheList);
                        //保存需要更新的订单，列表刷新使用
                        that.$store.commit('updateNeedRefresh', true);
                        if (type != 2 && type != 8) {
                            if (that.$store.state.orderData && that.$store.state.orderData.Id)
                                that.$store.commit('updateOrderList', { Id: that.submitData.EntpCusOId, IsAdd: true, Refresh: true });
                            else that.$store.commit('updateOrderList', { Id: that.submitData.EntpCusOId, IsAdd: true });
                        } else {
                            that.$store.commit('updateOrderList', { Id: that.submitData.EntpCusOId, IsAdd: false });
                        }
                        switch (printType) {
                            case 1:
                                if (that.isDefaultSet) that.dialogPrintCHVisible = true;
                                else {
                                    that.$refs.printDom.init(true);
                                }
                                break;
                            case 2:
                                that.dialogPrintEngVisible = true;
                                break;
                            case 0:
                                setTimeout(() => {
                                    that.$router.push('/salesManage/salesOrder');
                                }, 2000);
                                break;
                        }
                    }
                })
                .catch(() => {
                    that.saving = false;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            if (this.isCheckCode) {
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            } else {
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.priceChange();
            this.addPageChace(); //添加销售订单缓存
        },
        // 添加一行
        addItem(addPageChace) {
            if (this.dataReadonly) return;
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (!this.priceCanBeZero) {
                    if (!_dataList[i].MarketPrice) {
                        this.$util.warningMsg('请填写销售价');
                        return;
                    }
                }
            }
            if (addPageChace) {
                this.addPageChace(); //添加销售订单缓存
            }

            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }

            this.codeForm.key = '';
            this.codeForm.Page = 1;
            this.codeForm.Limit = 10;
            this.codeForm.stopLoad = false;

            this.nameForm.key = '';
            this.nameForm.Page = 1;
            this.nameForm.Limit = 10;
            this.nameForm.stopLoad = false;

            this.autoSerieForm.key = '';
            this.autoSerieForm.Page = 1;
            this.autoSerieForm.Limit = 10;
            this.autoSerieForm.stopLoad = false;

            this.dataList.push({
                WaitingOutQuantity: 0,
                Inventory: 0, //商品总数量
                StorageInventory: 0, //仓库库存数量
                ReferencePrice: 0,
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                GoodNameItem: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Count: this.initNumber,
                MarketPrice: '',
                CostPrice: 0,
                Unit: '',
                Remark: '',
                CodeRepeat: false,
                IsNew: false,
                WarehousedCount: 0,
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                State: 0,
                // 是否可编辑，用于报价转销售情况时新增数据情况
                canEdit: this.type == 4,
                LatestSalesTime: '',
                LatestQuoteTime: '',
                BillingPrice: '',
                MainImage: '',
                Origin: ''
            });

            this.priceChange();
            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);

            let that = this;
            that.$nextTick(() => {
                setTimeout(function () {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(isNew, type) {
            if (type === 'sapcode' && !isNew) {
                setTimeout(() => {
                    this.$refs[`sapcode`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage(this.submitStorageName, this.submitData);
            this.$util.setLocalStorage(this.dataStorageName, this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage(this.submitStorageName);
            this.$util.clearLocalStorage(this.dataStorageName);
        },
        //从缓存中读取数据
        getDataFromChace() {
            return new Promise(resolve => {
                let salesOrderModel = this.$util.getLocalStorage(this.submitStorageName);
                let datalist = this.$util.getLocalStorage(this.dataStorageName);
                if (salesOrderModel) {
                    if (this.isUseSource && salesOrderModel.CusSources) {
                        this.cusSourcesList = [];
                        this.cusSourcesList.push({ Text: salesOrderModel.CusSourcesName, Value: salesOrderModel.CusSources });
                    }
                    this.submitData = salesOrderModel;

                    let isexit = this.customerList.find(e => e.EntpCusId == salesOrderModel.EntpCusId);
                    if (!isexit) {
                        this.customerList.push({
                            EntpCusId: salesOrderModel.EntpCusId,
                            EntpCusName: salesOrderModel.EntpCusName,
                            CallNum: salesOrderModel.PhoneNum,
                            FullAddress: salesOrderModel.FullAddress
                        });
                    }

                    let i = this.SIdList.findIndex(item => {
                        if (item.EmployeeId == salesOrderModel.SId) {
                            return true;
                        }
                    });
                    if (i == -1) {
                        this.SIdList.push({
                            EmployeeId: salesOrderModel.SId,
                            EmployeeName: salesOrderModel.SName
                        });
                    }

                    this.FollowerList.push({
                        EmployeeId: salesOrderModel.FollowerId,
                        EmployeeName: salesOrderModel.FollowerName
                    });
                }
                if (salesOrderModel && salesOrderModel.WarehouseId) {
                    this.warehouseList.push({
                        WarehouseId: salesOrderModel.WarehouseId,
                        WarehouseName: salesOrderModel.WarehouseName,
                        Type: salesOrderModel.WarehouseType
                    });
                } else {
                    this.getdefaultWarehouses();
                }

                if (datalist && datalist.length > 0) {
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < datalist.length; i++) {
                        _allNum += Number(datalist[i].Count);
                        _allMoney += datalist[i].Count * datalist[i].MarketPrice ? datalist[i].Count * datalist[i].MarketPrice : 0;
                        datalist[i].hasLock = this.hasLock;
                    }
                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = datalist;
                }
                resolve();
            });
        },
        //从缓存中获取默认出仓仓库
        getdefaultWarehouses() {
            if (this.dataReadonly || !this.isDefaultWH) return;
            return new Promise(resolve => {
                this.$util.GetEntpCache({ CacheKey: 'defaultOutWarehouses', CacheType: '1' }, true).then(result => {
                    if (result) {
                        let data = JSON.parse(result);
                        let isexit = this.warehouseList.find(e => e.WarehouseId == data.WarehouseId);
                        if (!isexit) {
                            this.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType
                            });
                        }

                        this.$set(this.submitData, 'WarehouseId', data.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', data.WarehouseName);

                        this.warehouseType = data.WarehouseType;
                    }
                    resolve();
                });
            });
        },
        //从缓存中获取跟进人
        getSalesOrderFollower() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                this.$util.GetEntpCache({ CacheKey: 'salesOrder_follower' }, true).then(result => {
                    if (result) {
                        let data = JSON.parse(result);
                        let fo = this.FollowerList.filter(f => f.EmployeeId == data.FollowerId);
                        if (fo.length == 0) {
                            this.FollowerList.push({
                                EmployeeId: data.FollowerId,
                                EmployeeName: data.FollowerName
                            });
                        }
                        this.submitData.FollowerId = data.FollowerId;
                    }
                    resolve();
                });
            });
        },

        /**
         * 获取默认数据
         * ShipType 发货方式
         * PayType 结算方式
         * FullAddress 收货地址
         */
        getDefaultData() {
            let that = this;
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: that.submitData.EntpCusId,
                        type: '0'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        let isexit = that.customerList.find(e => e.EntpCusId == that.submitData.EntpCusId);
                        if (!isexit) {
                            that.customerList.push({
                                EntpCusId: that.submitData.EntpCusId,
                                EntpCusName: that.submitData.EntpCusName,
                                CallNum: data.CusPhone,
                                FullAddress: data.FullAddress
                            });
                        }

                        that.submitData.PhoneNum = data.CusPhone;
                        that.submitData.ShipType = data.ShipType;
                        that.submitData.PayType = data.PayType;
                        that.submitData.FullAddress = data.FullAddress;
                        that.submitData.LogisticId = data.LogisticId;
                        that.submitData.LogisticName = data.LogisticName;
                        that.submitData.LogisticItem = data.LogisticName;
                        if (data.LogisticId) {
                            let logist = that.logisticsList.find(e => e.Id == data.LogisticId);
                            if (!logist) {
                                that.logisticsList.push({
                                    Id: data.LogisticId,
                                    Name: data.LogisticName,
                                    Phone: ''
                                });
                            }
                        }
                        if (that.saveCustomerCache) {
                            that.submitData.Remark = data.Remark;
                        }
                        //价格等级逻辑
                        that.priceType = data.PriceType;
                        that.pricePoint = data.PricePoint;
                        that.calcType = data.CalcType;
                    }
                });
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.customerList = [];
            }
            if (this.cusForm.stopLoad) return;
            this.loading = true;
            this.$util
                .searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit)
                .then(data => {
                    this.cusForm.stopLoad = data && data.length < this.cusForm.Limit;
                    if (data) this.customerList = [...this.customerList, ...data];
                    //修改客户时要更新页面上展现的名称
                    if (this.customerList.length > 0) {
                        let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                        if (currCust) {
                            this.submitData.EntpCusName = currCust.EntpCusName;
                            this.submitData.PhoneNum = currCust.CallNum;
                            this.addressList = [];
                            //这里要处理多个地址问题
                            if (currCust.FullAddress) {
                                if (currCust.FullAddress.indexOf('{$}') != -1) {
                                    let addressArray = currCust.FullAddress.split('{$}');
                                    addressArray.forEach((e, i) => {
                                        this.addressList.push({
                                            value: e
                                        });
                                    });
                                    this.submitData.FullAddress = addressArray[0];
                                } else {
                                    this.submitData.FullAddress = currCust.FullAddress;
                                }
                            }
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustomer();
        },
        // 搜索汽配编码
        searchCode(key, item, index) {
            // 取消请求
            //   if (this.apcodeSource) {
            //     this.apcodeSource.cancel();
            //   }
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeForm.rowIndex = index;
                this.codeList = [];
            }
            if (item) {
                item.APCode = key;
            }
            if (this.codeForm.stopLoad) return;
            // 初始化对象
            //   this.apcodeSource = this.axios.CancelToken.source();

            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        APCode: this.codeForm.key,
                        GoodName: this.nameForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId,
                        OnlySeries: false,
                        SeriesName: this.autoSerieForm.key,
                        SFrom: 'apc'
                    },
                    hideLoading: true
                    //   cancelToken: this.apcodeSource.token // 取消操作标识
                })
                .then(res => {
                    let that = this;
                    this.loading = false;
                    if (!res.data) {
                        if (this.codeForm.Page == 1 && that.codeForm.key) {
                            let option = this.$refs[`sapcode`].options[0].$el;
                            if (option) {
                                option.onclick = function () {
                                    that.codeChange(that.codeForm.key, that.codeForm.rowIndex);
                                };
                            }
                        }
                        return;
                    }
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);

                    //ps 入过接口可以按条件的相似度来排序的化，下面的逻辑可以去除，比如查询条件为：1121时
                    that.$nextTick(() => {
                        if (that.codeForm.key) {
                            let hit = res.data.findIndex(c => c.APCode == that.codeForm.key);
                            if (hit != -1) {
                                hit = hit + (that.codeList.length - res.data.length);
                                let option = that.$refs[`sapcode`].options[hit].$el;
                                if (option) {
                                    option.onclick = function () {
                                        that.codeChange(that.codeForm.key, that.codeForm.rowIndex, option);
                                    };
                                }
                            }
                        }
                    });

                    this.seriesList = res.data;
                    this.nameList = res.data;
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },

        // 搜索名称
        searchName(key, item, index) {
            if (![undefined].includes(key)) {
                this.nameForm.Page = 1;
                this.nameForm.stopLoad = false;
                this.nameForm.key = key;
                this.nameForm.rowIndex = index;
                this.nameList = [];
            }
            if (item && key) {
                item.GoodName = key;
            }
            if (this.nameForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        APCode: this.codeForm.key,
                        GoodName: this.nameForm.key,
                        Page: this.nameForm.Page,
                        Limit: this.nameForm.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId,
                        OnlySeries: false,
                        SeriesName: this.autoSerieForm.key,
                        SFrom: 'gn'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.loading = false;
                    if (!res.data) {
                        if (this.nameForm.Page == 1 && that.nameForm.key) {
                            let option = this.$refs[`partsNameSelect`].options[0].$el;
                            if (option) {
                                option.onclick = function () {
                                    that.nameChange(that.nameForm.key, that.nameForm.rowIndex);
                                };
                            }
                        }
                        return;
                    }
                    this.nameForm.stopLoad = Array.isArray(res.data) && res.data.length < this.nameForm.Limit;
                    this.nameList = this.$util.uniqueArr(this.nameList, res.data);

                    that.$nextTick(() => {
                        if (that.nameForm.key) {
                            let hit = res.data.findIndex(c => c.GoodName == that.nameForm.key);
                            if (hit != -1) {
                                hit = hit + (that.nameList.length - res.data.length);
                                let option = that.$refs[`partsNameSelect`].options[hit].$el;
                                if (option) {
                                    option.onclick = function () {
                                        that.nameChange(that.nameForm.key, that.nameForm.rowIndex, option);
                                    };
                                }
                            }
                        }
                    });
                    this.seriesList = res.data;
                    this.codeList = res.data;
                });
        },
        // 汽配名称列表，加载更多
        searchNameLoad() {
            this.nameForm.Page += 1;
            this.searchName();
        },
        // 搜车系
        searchAutoSerie(key, item, index) {
            if (![undefined].includes(key)) {
                this.autoSerieForm.Page = 1;
                this.autoSerieForm.stopLoad = false;
                this.autoSerieForm.key = key;
                this.autoSerieForm.rowIndex = index;
                this.seriesList = [];
            }
            if (item && key) {
                item.AutoSerise = key;
                item.AutoSeriseItem = key;
            }
            if (this.autoSerieForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForSaleOrder',
                    data: {
                        APCode: this.codeForm.key,
                        GoodName: this.nameForm.key,
                        Page: this.autoSerieForm.Page,
                        Limit: this.autoSerieForm.Limit,
                        EntpId: this.userMsg.EntpId,
                        SId: this.submitData.WarehouseId,
                        CId: this.submitData.EntpCusId,
                        OnlySeries: true,
                        SeriesName: this.autoSerieForm.key,
                        SFrom: 'sn'
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.loading = false;
                    if (!res.data) {
                        if (this.autoSerieForm.Page == 1 && that.autoSerieForm.key) {
                            let option = this.$refs[`autoSeriseSelect`].options[0].$el;
                            if (option) {
                                option.onclick = function () {
                                    that.seriseChange(that.autoSerieForm.key, that.autoSerieForm.rowIndex);
                                };
                            }
                        }
                        return;
                    }
                    this.autoSerieForm.stopLoad = res.data.length < this.autoSerieForm.Limit;
                    this.seriesList = this.$util.uniqueArr(this.seriesList, res.data);

                    that.$nextTick(() => {
                        if (that.autoSerieForm.key) {
                            let hit = res.data.findIndex(c => c.AutoSerise == that.autoSerieForm.key);
                            if (hit != -1) {
                                hit = hit + (that.seriesList.length - res.data.length);
                                let option = that.$refs[`autoSeriseSelect`].options[hit].$el;
                                if (option) {
                                    option.onclick = function () {
                                        that.seriseChange(that.autoSerieForm.key, that.autoSerieForm.rowIndex, option);
                                    };
                                }
                            }
                        }
                    });
                    this.nameList = res.data;
                    this.codeList = res.data;
                });
        },
        // 车系列表，加载更多
        searchAutoSerieLoad() {
            this.autoSerieForm.Page += 1;
            this.searchAutoSerie();
        },
        //结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        //检查是否亏本
        CheckLoseMoney(costPrice, salePric) {
            let that = this;
            if (!that.LoseMoneyValue || !costPrice || !salePric) return false;

            let val = Number(salePric) * ((100 - that.LoseMoneyValue) / 100) < Number(costPrice);
            return val;
        },
        //名称改变
        nameChange(item, index, option) {
            if (!item) {
                this.dataList[index].GoodName = '';
            } else if (typeof item == 'string') {
                this.dataList[index].GoodName = item;
            } else {
                if (option) {
                    option.onclick = function () {};
                }
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].State = 0;

                this.dataList[index].CostPrice = item.CostPrice;
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].name_blur = item.GoodName;
                this.dataList[index].MainImage = item.MainImage;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].AutoSeriseItem = item.AutoSerise;
                this.dataList[index].Inventory = item.Inventory;
                this.dataList[index].StorageInventory = item.StorageInventory;
                this.dataList[index].ReferencePrice = item.ReferencePrice;
                this.dataList[index].MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';

                this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
                this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
                this.dataList[index].LatestSalesTime = item.LatestSalesTime;
                this.dataList[index].LatestQuoteTime = item.LatestQuoteTime;
                this.dataList[index].BillingPrice = item.MarketPrice == 0 ? '' : item.MarketPrice;
                this.dataList[index].Origin = item.Origin;

                this.$util
                    .getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId, '0', this.isIntentShow)
                    .then(data => {
                        if (data) {
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                            this.dataList[index].LatestSalesTime = data.LatestSalesTime;
                            this.dataList[index].LatestQuoteTime = data.LatestQuoteTime;
                            this.dataList[index].MarketPrice = data.LatestPrice > 0 ? data.LatestPrice : '';
                            if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                            if (this.isIntentShow) this.dataList[index].IntenCount = data.IntenCount;
                            if (this.IsNoZeroGoods && data.StorageInventory == 0) {
                                this.$util.warningMsg(`商品【${this.dataList[index].APCode}】当前库存商品为零`);
                            }
                        }
                    });
            }

            this.priceChange();
        },
        // 编码改变
        codeChange(value, index, option) {
            if (option) {
                option.onclick = function () {};
            }
            let isNew = true;
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
            }
            for (let i = 0; i < _list.length; i++) {
                let checkItem = this.isCheckCode ? _list[i].APCode : _list[i].EntpTempGoodsId;
                if (checkItem == value) {
                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;

                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].CostPrice = _list[i].CostPrice;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].GoodNameItem = _list[i].GoodName;
                    this.dataList[index].MainImage = _list[i].MainImage;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].StorageInventory = _list[i].StorageInventory;
                    this.dataList[index].ReferencePrice = _list[i].ReferencePrice;
                    this.dataList[index].LatestSalesTime = _list[i].LatestSalesTime;
                    this.dataList[index].LatestQuoteTime = _list[i].LatestQuoteTime;
                    this.dataList[index].MarketPrice = _list[i].LatestPrice > 0 ? _list[i].LatestPrice : '';
                    this.dataList[index].State = 0;
                    this.dataList[index].BillingPrice = _list[i].MarketPrice == 0 ? '' : _list[i].MarketPrice;
                    this.dataList[index].Origin = _list[i].Origin;
                    isNew = false;

                    this.$util
                        .getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId, '0', this.isIntentShow)
                        .then(data => {
                            if (data) {
                                this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                                this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                                this.dataList[index].StorageInventory = data.StorageInventory;
                                this.dataList[index].LatestSalesTime = data.LatestSalesTime;
                                this.dataList[index].LatestQuoteTime = data.LatestQuoteTime;

                                this.dataList[index].MarketPrice = data.LatestPrice > 0 ? data.LatestPrice : '';
                                if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                                if (this.isIntentShow) this.dataList[index].IntenCount = data.IntenCount;
                                if (this.IsNoZeroGoods && data.StorageInventory == 0) {
                                    this.$util.warningMsg(`商品【${this.dataList[index].APCode}】当前库存商品为零`);
                                }
                            }
                        });
                    break;
                }
            }
            if (isNew && value && this.isCheckCode) {
                let that = this;
                that.$refs.infiniteTable.clearActived();
                this.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].StorageInventory = 0;
                        that.dataList[index].MarketPrice = '';
                        that.dataList[index].ReferencePrice = 0;
                        that.dataList[index].State = 0;
                        that.dataList[index].BillingPrice = '';
                        that.dataList[index].Origin = '';
                        that.dataList[index].IsNew = true;
                        that.$refs.infiniteTable.setActiveRow(that.dataList[index]);
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].AutoSeriseItem = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].GoodNameItem = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                    this.dataList[index].Origin = data.Origin;
                                } else {
                                    that.addAPParams = {
                                        APCode: that.dataList[index].APCode,
                                        index: index
                                    };
                                    that.addAPVisible = true;
                                    if (that.$refs[`sapcode`]) {
                                        that.$refs[`sapcode`].blur();
                                    }
                                }
                            });
                    }
                });
            } else {
                let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
                inputAll[0].focus();
            }
            this.priceChange();
        },
        //车型改变 AutoSeriseItem值仅仅用于选中值为对象的效果，实际上保存的数据还是AutoSerise
        seriseChange(item, index, option) {
            if (!item) {
                this.dataList[index].AutoSerise = '';
            } else if (typeof item == 'string') {
                this.dataList[index].AutoSerise = item;
            } else {
                if (option) {
                    option.onclick = function () {};
                }
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].State = 0;
                this.dataList[index].CostPrice = item.CostPrice;
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].MainImage = item.MainImage;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].autoSerise_blur = item.AutoSerise;
                this.dataList[index].Inventory = item.Inventory;
                this.dataList[index].StorageInventory = item.StorageInventory;
                this.dataList[index].ReferencePrice = item.ReferencePrice;
                this.dataList[index].MarketPrice = item.LatestPrice > 0 ? item.LatestPrice : '';
                this.dataList[index].OrderWaitOutQuantity = item.OrderWaitOutQuantity;
                this.dataList[index].POrderWaitInQuantity = item.POrderWaitInQuantity;
                this.dataList[index].LatestSalesTime = item.LatestSalesTime;
                this.dataList[index].LatestQuoteTime = item.LatestQuoteTime;
                this.dataList[index].BillingPrice = item.MarketPrice == 0 ? '' : item.MarketPrice;
                this.dataList[index].Origin = item.Origin;
                this.$util
                    .getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId, '0', this.isIntentShow)
                    .then(data => {
                        if (data) {
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                            this.dataList[index].LatestSalesTime = data.LatestSalesTime;
                            this.dataList[index].LatestQuoteTime = data.LatestQuoteTime;
                            this.dataList[index].MarketPrice = data.LatestPrice > 0 ? data.LatestPrice : '';
                            if (data.ReferencePrice) this.dataList[index].ReferencePrice = data.ReferencePrice;
                            if (this.isIntentShow) this.dataList[index].IntenCount = data.IntenCount;
                            if (this.IsNoZeroGoods && data.StorageInventory == 0) {
                                this.$util.warningMsg(`商品【${this.dataList[index].APCode}】当前库存商品为零`);
                            }
                        }
                    });
                this.priceChange();
            }
        },
        // 客户改变
        customerChange(value) {
            let that = this;
            if (!value) {
                that.submitData.EntpCusName = '';
                that.submitData.PhoneNum = '';
                that.addressList = [];
                that.submitData.FullAddress = '';
            } else {
                //获取客户的名称、手机号、地址等数据
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                    that.submitData.PhoneNum = currCust.CallNum;
                    that.addressList = [];
                    //这里要处理多个地址问题
                    if (currCust.FullAddress) {
                        if (currCust.FullAddress.indexOf('{$}') != -1) {
                            let addressArray = currCust.FullAddress.split('{$}');
                            addressArray.forEach((e, i) => {
                                that.addressList.push({
                                    value: e
                                });
                            });
                            that.submitData.FullAddress = addressArray[0];
                        } else {
                            that.submitData.FullAddress = currCust.FullAddress;
                        }
                    }
                }
                //查询对客户最新的商品销售价格
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsLatestPriceByCId',
                                data: {
                                    cId: value,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getGoods = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getGoods) {
                                        //替换销售价
                                        e.MarketPrice = getGoods.Price;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
            this.getDefaultData();
        },
        //查地址列表
        querySearch(queryString, cb) {
            var restaurants = this.addressList;
            cb(restaurants);
        },
        //业务员改变
        sIdChange(value) {
            let _list = this.SIdList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.SName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //跟单采购员的改变
        followerChange(value) {
            let _list = this.FollowerList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].EmployeeId == value) {
                    this.submitData.FollowerName = _list[i].EmployeeName;
                    return;
                }
            }
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当客户下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event && that.nameList.length == 0 && that.isPreloadApCodeList) {
                that.searchName('');
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event, item) {
            let that = this;
            if (event && that.seriesList.length == 0 && that.isPreloadApCodeList) {
                that.searchAutoSerie('', item);
            }
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;
                        that.warehouseType = that.warehouseList[i].Type;
                        break;
                    }
                }
                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: val,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.StorageInventory = getStorage.Count;
                                        e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
        },
        // 设置展示合计数据行
        setSummaries(param) {
            const { data } = param;
            let num = 0;
            let price = 0;
            data.forEach(ele => {
                num += Number(ele.Count);
                price += Number(ele.Count * ele.MarketPrice ? (ele.Count * ele.MarketPrice).toFixed(3) : 0);
            });
            var countColIndex = 0;
            var sumColIndex = 0;
            countColIndex = param.columns.findIndex(item => {
                return item.title == '数量';
            });
            sumColIndex = param.columns.findIndex(item => {
                return item.title == '销售总价';
            });

            var arr = new Array(param.columns.length);
            if (countColIndex != -1) {
                arr[countColIndex] = num;
                arr[countColIndex - 1] = '总数量';
            }
            if (sumColIndex != -1) {
                arr[sumColIndex] = price.toFixed(2);
                arr[sumColIndex - 1] = '销售商品总额';
            }
            return [arr];
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if (this.isCheckCode) rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        logisticVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.logisticsList.length <= 1) that.searchLogistic();
            }
        },
        searchLogistic(key) {
            this.loading = true;
            this.$util
                .searchLogistic(key, 1, this.Limit)
                .then(data => {
                    this.logisticsList = data ? data : [];
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        logisticChange(item) {
            if (!item) {
                this.submitData.LogisticName = '';
                this.submitData.LogisticId = '';
                this.submitData.LogisticItem = '';
            } else if (typeof item == 'string') {
                this.submitData.LogisticName = item;
                this.submitData.LogisticId = '';
            } else {
                this.submitData.LogisticName = item.EntpCusName;
                this.submitData.LogisticId = item.EntpCusId;
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'Enter') {
                if (code == 'Count' || code == 'MarketPrice') {
                    that.addItem(true);
                } else {
                    if (code == 'APCode') {
                        that.codeChange(row.APCode, index);
                    } else {
                        let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
                        inputAll[0].focus();
                    }
                }
            } else if (ev.key == 'ArrowLeft') {
                if (code == 'Count') {
                    if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                    else that.$refs[`partsNameSelect`].focus();
                } else if (code == 'MarketPrice') {
                    let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'AutoSerise') {
                    that.$refs[`autoSeriseSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[1].focus();
                } else if (code == 'Origin') {
                    that.$refs[`autoSeriseSelect`].focus();
                }
            } else if (ev.key == 'ArrowRight') {
                if (code == 'Count') {
                    let inputAll = document.querySelectorAll('.sales-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'APCode') {
                    that.$refs[`sapcode`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[1].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[2].focus();
                } else if (code == 'AutoSerise') {
                    if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                    else that.$refs[`countRef`].focus();
                } else if (code == 'Origin') {
                    that.$refs[`countRef`].focus();
                }
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgList.length <= 1)
                    that.$util.getParentOrgs().then(data => {
                        that.orgList = data;
                    });
            }
        },
        orgChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.orgList.length; i++) {
                    if (val == that.orgList[i].Id) {
                        that.submitData.OrgName = that.orgList[i].Name;
                        break;
                    }
                }
            } else {
                that.submitData.OrgName = '';
            }
        },
        sourceVisibleChange(event) {
            let that = this;
            if (event) {
                that.$util.getSalesOrderSources().then(data => {
                    that.cusSourcesList = data;
                });
            }
        },
        sourceChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.cusSourcesList.length; i++) {
                    if (val == that.cusSourcesList[i].Value) {
                        that.submitData.CusSourcesName = that.cusSourcesList[i].Text;
                        break;
                    }
                }
            } else {
                that.submitData.CusSourcesName = '';
            }
        },
        urgentchange(event, row) {
            let that = this;
            //IsUrgent会是false是因为去掉勾选后已经改变了值
            if (!row.IsUrgent && row.WarehousedCount > 0) {
                that.dataList.forEach(e => {
                    if (row.EntpTempGoodsId == e.EntpTempGoodsId) {
                        e.WarehousedCount = 0;
                        e.IsDelivery = false;
                    }
                });
            } else if (row.IsUrgent && that.type == 8) {
                that.dataList.forEach(e => {
                    if (row.EntpTempGoodsId == e.EntpTempGoodsId) {
                        e.WarehousedCount = e.Count;
                        e.IsDelivery = true;
                    }
                });
            }
        }
    }
};
</script>
<style lang="less" scoped>
.s-btn,
.s-btn:focus,
.s-btn.is-active,
.s-btn.is-disabled:active,
.s-btn:active {
    padding: 3px;
    font-size: 15px;
    color: #fff;
    background: #ea7060;
    background-color: #ea7060;
    margin-right: 2px;
}

.s-btn.is-disabled:hover,
.s-btn:hover,
.s-btn.is-disabled {
    padding: 4px 4px;
    background: #f3bb53;
    background-color: #f3bb53;
    color: #fff;
}

.b-btn,
.b-btn:focus,
.b-btn.is-active,
.b-btn.is-disabled:active,
.b-btn:active {
    padding: 3px;
    font-size: 15px;
    color: #fff;
    background: #bac225;
    background-color: #bac225;
    margin-right: 2px;
}

.b-btn.is-disabled:hover,
.b-btn:hover,
.b-btn.is-disabled {
    padding: 4px 4px;
    background: #f3bb53;
    background-color: #f3bb53;
    color: #fff;
}

.el-form-item {
    margin-bottom: 0px;
}
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 40%;
    float: left;
}
.form-uploadImg {
    margin-bottom: 20px;
}
.form-uploadImg div {
    width: 100%;
    font-size: 14px;
    margin-bottom: 10px;
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 36px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    flex-grow: 1;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
.info-icon {
    vertical-align: top;
    margin-top: 2px;
    margin-right: 5px;
}
.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}
.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .color-red {
        margin-right: 4px;
    }
    .sort-view {
        display: flex;
        flex-direction: column;
        i {
            line-height: 8px;
            cursor: pointer;
        }
        .active {
            color: #409eff;
        }
    }
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
.customer-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .grid-content {
        flex: 1;
    }
    .customer-checked {
        margin-left: 24px;
    }
}
.el-icon-picture {
    color: rgb(240, 155, 27);
    font-size: 18px;
    vertical-align: top;
    margin-top: 3px;
    cursor: pointer;
    margin-right: 3px;
}
</style>
<style lang="less">
.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
.pop-cls {
    font-size: 18px;
    padding: 10px 12px;
    color: #fff;
    background-color: #303133;
    .popper__arrow {
        color: #303133;
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.loseMoneyWarning {
    .el-input__inner {
        border: 1px solid #e6a23c;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
.sales-order-edit-v2 {
    #search-dialog {
        margin-right: 35px;
    }
    .el-row {
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 10px;
        }
    }
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 8px 0;
                }
                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .operate {
                    padding: 0 12px;
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;

            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .infinite-list-special-class {
        .elx-table {
            .elx-table--body-wrapper {
                padding-bottom: 0 !important;
            }
        }
    }
    .bottom-div {
        margin-top: 24px;
        .ship-amount {
            text-align: right;
            margin-bottom: 16px;
            .discount-count {
                font-size: 15px;
                font-weight: bold;
                color: #f00;
            }
        }
        .part {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 16px;
        }
        .no-fee {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
        }
        .subzone {
            .dismoney {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                height: 32px;
                .percent-view {
                    display: flex;
                    align-items: center;
                    span {
                        margin-left: 12px;
                    }
                }
                .el-input-number {
                    width: 110px;
                    .el-input__inner {
                        height: 32px;
                    }
                }
                .el-select {
                    margin-right: 12px;
                    .el-input__inner {
                        width: 110px;
                        height: 32px;
                        color: red;
                    }
                    .el-input__suffix {
                        top: 4px;
                    }
                    .is-focus {
                        .el-input__suffix {
                            top: -4px;
                        }
                    }
                }
            }
            .discount-count {
                font-size: 15px;
                font-weight: bold;
                color: #f00;
            }
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .salecounts-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }

        .sp-i {
            height: 24px;
            margin-left: -6px;
            margin-right: 2px;
        }
        .el-icon-info {
            color: #87a7d6;
            font-size: 18px;
            vertical-align: top;
            cursor: pointer;
            margin-top: 2px;
            margin-right: 3px;
        }
    }
}
</style>
